<template>
    <div
        class="cards__block"
        v-if="fiscal"
        :class="{ 'cards__block--half ': isHalf }"
    >
        <!-- <p class="cards__block__top cards__block__top--center desktop">38 ΠΑΡΑΛΕΙΨΕΙΣ</p> -->
        <p
            class="cards__block__top cards__block__top--info cards__block__top--black mobile"
        >
            Βλέπετε μια συνοπτική καταγραφή των δεδομένων της δήλωσης Πόθεν
            Έσχες του/της βουλευτη. Για την αναλυτική έκδοση επισκεφτείτε την
            ιστοσελίδα από desktop.
        </p>

        <div class="card revenues" id="revenues">
            <h3 class="card__title">ΕΙΣΟΔΗΜΑΤΑ</h3>
            <div class="card__table">
                <div class="card__table__head card__table__head--left">
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΕΙΣΟΔΗΜΑ ΑΠΟ ΕΠΙΧΕΙΡΗΜΑΤΙΚΗ ΔΡΑΣΤΗΡΙΟΤΗΤΑ'"
                        :class="{ active: revenuesFilter == 'ΕΠΙΧΕΙΡΗΜΑΤΙΚΗ' }"
                        @click="
                            revenuesFilter == 'ΕΠΙΧΕΙΡΗΜΑΤΙΚΗ'
                                ? (revenuesFilter = null)
                                : (revenuesFilter = 'ΕΠΙΧΕΙΡΗΜΑΤΙΚΗ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="61.854"
                                height="35.736"
                                viewBox="0 0 61.854 35.736"
                            >
                                <g
                                    id="Group_3579"
                                    data-name="Group 3579"
                                    transform="translate(-956.179 -340.107)"
                                >
                                    <path
                                        id="Path_6324"
                                        data-name="Path 6324"
                                        d="M1016.644,370.469a6.024,6.024,0,0,1-9.776-2.186h4.772a.753.753,0,1,0,0-1.506h-5.146a6.205,6.205,0,0,1-.04-.672,6.063,6.063,0,0,1,.065-.836h7.889a.753.753,0,0,0,0-1.506h-7.48a6.029,6.029,0,0,1,9.819-1.922.753.753,0,0,0,1.065-1.064,7.531,7.531,0,0,0-12.487,2.986h-1.539a.753.753,0,0,0,0,1.506H1005a7.683,7.683,0,0,0-.049.836c0,.227.014.45.034.672h-1.2a.753.753,0,1,0,0,1.506h1.486a7.534,7.534,0,0,0,12.411,3.276.753.753,0,1,0-1.039-1.09Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6325"
                                        data-name="Path 6325"
                                        d="M965.854,357.067h-8.575a1.1,1.1,0,0,0-1.1,1.1v16.575a1.1,1.1,0,0,0,1.1,1.1h8.575a1.1,1.1,0,0,0,1.1-1.1V358.167A1.1,1.1,0,0,0,965.854,357.067Zm-.9,16.776h-6.776V359.067h6.776Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6326"
                                        data-name="Path 6326"
                                        d="M981.215,348.367H972.64a1.1,1.1,0,0,0-1.1,1.1v25.275a1.1,1.1,0,0,0,1.1,1.1h8.575a1.1,1.1,0,0,0,1.1-1.1V349.467A1.1,1.1,0,0,0,981.215,348.367Zm-.9,25.476H973.54V350.367h6.775Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6327"
                                        data-name="Path 6327"
                                        d="M996.576,340.107H988a1.1,1.1,0,0,0-1.1,1.1v33.535a1.1,1.1,0,0,0,1.1,1.1h8.575a1.1,1.1,0,0,0,1.1-1.1V341.207A1.1,1.1,0,0,0,996.576,340.107Zm-.9,33.736H988.9V342.107h6.776Z"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_revenue_epixirimatiki | seprator }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΕΙΣΟΔΗΜΑ ΑΠΟ ΑΚΙΝΗΤΑ'"
                        :class="{
                            active: revenuesFilter == 'ΑΚΙΝΗΤΑ',
                            empty: !total_revenue_akinita,
                        }"
                        @click="
                            revenuesFilter == 'ΑΚΙΝΗΤΑ'
                                ? (revenuesFilter = null)
                                : (revenuesFilter = 'ΑΚΙΝΗΤΑ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="63.555"
                                height="45.971"
                                viewBox="0 0 63.555 45.971"
                            >
                                <g
                                    id="Group_3583"
                                    data-name="Group 3583"
                                    transform="translate(-954.743 -735.935)"
                                >
                                    <path
                                        id="Path_6339"
                                        data-name="Path 6339"
                                        d="M1011.931,763.428a.778.778,0,0,0-1.054.044h0a.78.78,0,0,0,.065,1.161l4.142,3.3h-11.835V753.095l7.705,5.9a1,1,0,0,0,1.215-1.588l-8.92-6.826V741.57a1,1,0,0,0-2,0v7.477l-16.863-12.906a1,1,0,0,0-1.2-.012L955.15,756.774a1,1,0,0,0,1.186,1.612l7.974-5.873v28.393a1,1,0,0,0,1,1h36.938a1,1,0,0,0,1-1V769.625l11.86-.013-4.167,3.33a.789.789,0,1,0,1,1.218l6.354-5.365Zm-10.683,16.478H966.31v-28.2a.974.974,0,0,0-.179-.539l17.634-12.987,17.483,13.379v16.374h-9.835a.85.85,0,0,0,0,1.7l9.834-.01Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6340"
                                        data-name="Path 6340"
                                        d="M979.666,761.788a5.989,5.989,0,0,1,4.263,1.766.753.753,0,0,0,1.065-1.065,7.531,7.531,0,0,0-12.486,2.987h-1.54a.753.753,0,0,0,0,1.506h1.211a7.68,7.68,0,0,0-.049.835c0,.227.015.451.034.673h-1.2a.753.753,0,0,0,0,1.506h1.486a7.535,7.535,0,0,0,12.412,3.276.753.753,0,1,0-1.04-1.09A6.024,6.024,0,0,1,974.05,770h4.773a.753.753,0,0,0,0-1.506h-5.147a6.209,6.209,0,0,1-.04-.673,6.061,6.061,0,0,1,.065-.835h7.889a.753.753,0,0,0,0-1.506h-7.48A6.038,6.038,0,0,1,979.666,761.788Z"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_revenue_akinita | seprator }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="
                            'ΣΥΝΟΛΙΚΟ ΚΑΘΑΡΟ ΕΙΣΟΔΗΜΑ ΑΠΟ ΜΙΣΘΩΤΕΣ ΥΠΗΡΕΣΙΕΣ, ΕΠΙΔΟΜΑΤΑ,ΠΡΟΣΘΕΤΕΣ ΑΜΟΙΒΕΣ Κ.Λ.Π.(ΦΟΡΟΛΟΓΟΥΜΕΝΑ, ΦΟΡΟΛΟΓΟΥΜΕΝΑ ΜΕ ΕΙΔΙΚΟ ΤΡΟΠΟ, ΦΟΡΟΛΟΓ. ΑΥΤΟΤΕΛΩΣ, ΑΦΟΡΟΛΟΓΗΤΑ)'
                        "
                        :class="{
                            active: revenuesFilter == 'ΜΙΣΘΩΤΕΣ ΥΠΗΡΕΣΙΕΣ',
                            empty: !total_revenue_various,
                        }"
                        @click="
                            revenuesFilter == 'ΜΙΣΘΩΤΕΣ ΥΠΗΡΕΣΙΕΣ'
                                ? (revenuesFilter = null)
                                : (revenuesFilter = 'ΜΙΣΘΩΤΕΣ ΥΠΗΡΕΣΙΕΣ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="49.109"
                                height="49.109"
                                viewBox="0 0 49.109 49.109"
                            >
                                <g
                                    id="Group_3584"
                                    data-name="Group 3584"
                                    transform="translate(-950.76 -835.238)"
                                >
                                    <path
                                        id="Path_6341"
                                        data-name="Path 6341"
                                        d="M975.314,835.238a24.555,24.555,0,1,0,24.555,24.555A24.583,24.583,0,0,0,975.314,835.238Zm0,47.109a22.555,22.555,0,1,1,22.555-22.554A22.579,22.579,0,0,1,975.314,882.347Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6342"
                                        data-name="Path 6342"
                                        d="M976.265,853.6a5.99,5.99,0,0,1,4.264,1.766.753.753,0,0,0,1.065-1.065,7.532,7.532,0,0,0-12.487,2.986h-1.54a.754.754,0,0,0,0,1.507h1.212a7.427,7.427,0,0,0-.049.835c0,.227.014.451.034.673h-1.2a.753.753,0,0,0,0,1.506h1.487a7.533,7.533,0,0,0,12.411,3.275.753.753,0,0,0-1.04-1.09,6.023,6.023,0,0,1-9.776-2.185h4.773a.753.753,0,0,0,0-1.506h-5.147a6.21,6.21,0,0,1-.039-.673,5.89,5.89,0,0,1,.065-.835h7.889a.754.754,0,0,0,0-1.507h-7.481A6.04,6.04,0,0,1,976.265,853.6Z"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_revenue_various | seprator }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="
                            'ΕΙΣΟΔΗΜΑ ΑΠΟ ΑΓΡΟΤΙΚΗ ΕΠΙΧΕΙΡΗΜΑΤΙΚΗ ΔΡΑΣΤΗΡΙΤΟΤΗΤΑ'
                        "
                        :class="{
                            active: revenuesFilter == 'ΑΓΡΟΤΙΚΗ',
                            empty: !total_revenue_agrotika,
                        }"
                        @click="
                            revenuesFilter == 'ΑΓΡΟΤΙΚΗ'
                                ? (revenuesFilter = null)
                                : (revenuesFilter = 'ΑΓΡΟΤΙΚΗ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="56.642"
                                height="47.96"
                                viewBox="0 0 56.642 47.96"
                            >
                                <g
                                    id="Group_3580"
                                    data-name="Group 3580"
                                    transform="translate(-953.994 -427.232)"
                                >
                                    <path
                                        id="Path_6328"
                                        data-name="Path 6328"
                                        d="M1010.134,456.321a.5.5,0,0,0-.5-.487h-.012c-.242.006-24.4.794-41.826,18.071a.5.5,0,0,0,.706.711c17.13-16.991,40.907-17.776,41.145-17.782A.5.5,0,0,0,1010.134,456.321Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6329"
                                        data-name="Path 6329"
                                        d="M1010.383,461.622a.511.511,0,0,0-.547-.449c-.187.018-18.91,1.961-30.376,12.793a.5.5,0,1,0,.687.726c11.22-10.6,29.6-12.506,29.787-12.523A.5.5,0,0,0,1010.383,461.622Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6330"
                                        data-name="Path 6330"
                                        d="M1010.624,466.895a.5.5,0,0,0-.6-.375c-.544.126-13.384,3.123-18.877,7.486a.5.5,0,0,0,.621.783c5.317-4.222,18.35-7.264,18.481-7.294A.5.5,0,0,0,1010.624,466.895Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6331"
                                        data-name="Path 6331"
                                        d="M1010.383,451.019a1,1,0,0,0-.978-1.021,72.19,72.19,0,0,0-19.685,3.253c-17.915-9.495-33.833-9.27-34.495-9.253a1,1,0,0,0,.043,2,75.87,75.87,0,0,1,31.742,8.111c-2.068.695-4.215,1.507-6.414,2.456a70.23,70.23,0,0,0-25.588-6.731H955a.5.5,0,0,0-.013,1,69.056,69.056,0,0,1,24.409,6.268c-2.039.92-4.116,1.961-6.211,3.134a67.513,67.513,0,0,0-18.387-5.063.506.506,0,0,0-.547.449.5.5,0,0,0,.449.547,66.408,66.408,0,0,1,17.4,4.682q-2.714,1.576-5.437,3.47a91.65,91.65,0,0,0-12.052-3.8.5.5,0,0,0-.225.975,91.649,91.649,0,0,1,11.311,3.515,77.319,77.319,0,0,0-9.91,8.48,1,1,0,1,0,1.424,1.4c22.92-23.258,51.871-22.892,52.155-22.9A1.029,1.029,0,0,0,1010.383,451.019Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6332"
                                        data-name="Path 6332"
                                        d="M980.239,436.193a.753.753,0,0,0,.753.753h1.487a7.534,7.534,0,0,0,12.411,3.276.753.753,0,0,0-1.039-1.09,6.024,6.024,0,0,1-9.776-2.186h4.772a.753.753,0,0,0,0-1.506H983.7a5.981,5.981,0,0,1-.04-.672,6.053,6.053,0,0,1,.065-.836h7.889a.753.753,0,0,0,0-1.506h-7.481a6.03,6.03,0,0,1,9.82-1.922.753.753,0,0,0,1.065-1.065,7.532,7.532,0,0,0-12.487,2.987h-1.54a.753.753,0,0,0,0,1.506H982.2a7.445,7.445,0,0,0-.049.836c0,.226.014.45.034.672h-1.2A.753.753,0,0,0,980.239,436.193Z"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_revenue_agrotika | seprator }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΜΕΡΙΣΜΑΤΑ, ΤΟΚΟΙ, ΔΙΚΑΙΩΜΑΤΑ'"
                        :class="{
                            active: revenuesFilter == 'ΤΟΚΟΙ',
                            empty: !total_revenue_stocks,
                        }"
                        @click="
                            revenuesFilter == 'ΤΟΚΟΙ'
                                ? (revenuesFilter = null)
                                : (revenuesFilter = 'ΤΟΚΟΙ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="45.122"
                                height="50.545"
                                viewBox="0 0 45.122 50.545"
                            >
                                <g
                                    id="Group_3581"
                                    data-name="Group 3581"
                                    transform="translate(-958.983 -523.624)"
                                >
                                    <path
                                        id="Path_6333"
                                        data-name="Path 6333"
                                        d="M981.687,530.573a.624.624,0,0,0-.624.625v20.759l-17.978-10.38a.622.622,0,0,0-.474-.062.629.629,0,0,0-.379.292,21.6,21.6,0,0,0-3.01,11.231,22.465,22.465,0,1,0,22.465-22.465Zm0,43.681a21.239,21.239,0,0,1-21.216-21.216,20.034,20.034,0,0,1,2.537-10.064l18.367,10.6a.624.624,0,0,0,.936-.541V531.83a21.216,21.216,0,0,1-.625,42.423Z"
                                        transform="translate(-0.046 -1.333)"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6334"
                                        data-name="Path 6334"
                                        d="M978.209,546.629a.624.624,0,0,0,.936-.541v-21.84a.624.624,0,0,0-.624-.625,21.953,21.953,0,0,0-19.454,11.232.624.624,0,0,0,.229.853Zm-.313-21.749v20.127l-17.43-10.063A20.674,20.674,0,0,1,977.9,524.881Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6335"
                                        data-name="Path 6335"
                                        d="M998.05,559.28a4.841,4.841,0,0,1,3.445,1.428.609.609,0,1,0,.861-.861,6.086,6.086,0,0,0-10.09,2.413h-1.245a.609.609,0,0,0,0,1.217H992a6.009,6.009,0,0,0-.04.676c0,.183.012.364.027.543h-.967a.609.609,0,0,0,0,1.217h1.2a6.089,6.089,0,0,0,10.031,2.647.609.609,0,1,0-.84-.881,4.868,4.868,0,0,1-7.9-1.767h3.857a.609.609,0,0,0,0-1.217h-4.16a5.036,5.036,0,0,1-.032-.543,4.886,4.886,0,0,1,.053-.676H999.6a.609.609,0,0,0,0-1.217H993.56A4.88,4.88,0,0,1,998.05,559.28Z"
                                        transform="translate(-6.03 -6.608)"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_revenue_stocks | seprator }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="
                            'ΠΟΣΑ ΑΠΟ ΔΙΑΘΕΣΗ ΠΕΡΙΟΥΣΙΑΚΩΝ ΣΤΟΙΧΕΙΩΝ, ΔΑΝΕΙΑ, ΔΩΡΕΕΣ, ΚΛΗΡΟΝΟΜΙΕΣ, ΕΠΙΔΟΜΑ ΑΛΛΟΔ., ΕΦΑΠΑΞ ΚΛΠ'
                        "
                        :class="{
                            active: revenuesFilter == 'ΕΦΑΠΑΞ',
                            empty: !total_revenue_efapax,
                        }"
                        @click="
                            revenuesFilter == 'ΕΦΑΠΑΞ'
                                ? (revenuesFilter = null)
                                : (revenuesFilter = 'ΕΦΑΠΑΞ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                viewBox="0 0 60 60"
                                width="50"
                                height="50"
                                xml:space="preserve"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="m15.6 32.4c0 0.7 0.6 1.2 1.2 1.2h2.5c1.6 5.1 6.3 8.9 11.9 8.9s6.3-1.2 8.6-3.4c0.5-0.5 0.5-1.3 0-1.8s-1.3-0.5-1.8 0c-1.9 1.8-4.3 2.8-6.9 2.8-4.2 0-7.8-2.6-9.3-6.4h7.9c0.7 0 1.2-0.6 1.2-1.2s-0.6-1.2-1.2-1.2h-8.5v-1.1s0-0.9 0.1-1.4h13c0.7 0 1.2-0.6 1.2-1.2s-0.6-1.2-1.2-1.2h-12.4c1.5-3.6 5.1-6.1 9.2-6.1s5.2 1 7.1 2.9c0.5 0.5 1.3 0.5 1.8 0s0.5-1.3 0-1.8c-2.4-2.4-5.5-3.7-8.8-3.7-5.5 0-10.2 3.6-11.8 8.6h-2.5c-0.7 0-1.2 0.6-1.2 1.2s0.6 1.2 1.2 1.2h2v1.4s0 0.7 0 1.1h-2c-0.7 0-1.2 0.6-1.2 1.2h-0.1z"
                                />
                                <path
                                    d="m22.9 52.8c0.2 0.3 3.5 4.5 6.4 5.4 0.9 0.3 2 0.4 3.1 0.5 0.6 0 1.2 0.2 1.8 0.2 0.4 0 0.9 0.2 1.3 0.2 1.1 0.2 2.2 0.4 3.2 0.4s0.4 0 0.6 0c1.4-0.1 2.9-0.9 4.4-1.7 0.4-0.2 0.9-0.5 1.3-0.7 0.3-0.2 0.6-0.3 0.9-0.4 2.3-1.1 4.3-2.1 6.7-2.8v1.4c0 0.4 0.4 0.8 0.8 0.8h5.3c0.4 0 0.8-0.4 0.8-0.8v-11c0-0.4-0.4-0.8-0.8-0.8h-5.3c-0.4 0-0.8 0.4-0.8 0.8v1.2c-2-0.6-4.2-1.2-6.7-1.2s-0.5 0-0.8 0c-1.8 0-3.3 0.8-4.7 1.4-0.8 0.4-1.6 0.7-2.3 0.9-1 0.3-2.3 0.4-3.6 0.4-2.9 0.2-5.5 0.4-5.7 2.4 0 0.7 0 1.2 0.4 1.6 0.5 0.5 1.3 0.8 2.7 0.8s1.9 0 2.8-0.2c0.9 0 1.9-0.2 2.8-0.2s1.3 0 1.7 0.2h0.2l-0.2 0.1c-1.6 0.6-3.8 1.4-6.1 1.4s-2.6-0.2-3.9-0.7c-0.7-0.3-1.4-0.7-2.1-1.2-1.1-0.7-2.2-1.4-3.2-1.4s-0.7 0.1-1 0.3c-0.6 0.4-0.4 1.8 0 2.5v0.2zm30.4-8.4v0l5.4-0.1s0.1 0 0.1 0.1v11s0 0.1-0.1 0.1h-5.3s-0.1 0-0.1-0.1v-11zm-29.9 6.5c0.2-0.1 0.4-0.2 0.6-0.2 0.8 0 1.8 0.7 2.8 1.3 0.7 0.5 1.5 1 2.2 1.2 1.4 0.5 2.7 0.8 4.2 0.8 2.4 0 4.7-0.8 6.4-1.4l1.2-0.5c0.2 0 0.3-0.2 0.2-0.4 0-0.2-0.1-0.3-0.3-0.4l-1.2-0.4c-0.5-0.2-1.2-0.2-1.9-0.2s-1.9 0-2.8 0.2c-0.9 0-1.9 0.2-2.7 0.2s-1.9-0.2-2.2-0.5c-0.2-0.2-0.3-0.5-0.2-1 0.1-1.3 2.5-1.5 5-1.7 1.3 0 2.6-0.2 3.7-0.5 0.8-0.2 1.6-0.6 2.5-1 1.3-0.6 2.7-1.3 4.4-1.4h0.7c2.4 0 4.7 0.6 6.7 1.2v6.8c-2.6 0.7-4.7 1.7-7 2.9-0.3 0.2-0.6 0.3-0.9 0.4-0.4 0.2-0.9 0.5-1.3 0.7-1.4 0.7-2.9 1.5-4.1 1.6h-0.5c-0.9 0-2-0.2-3-0.4-0.5 0-0.9-0.2-1.4-0.2-0.6 0-1.2-0.2-1.8-0.2-1.1-0.1-2.2-0.3-3-0.5-2.5-0.8-5.7-4.7-5.9-5-0.3-0.6-0.3-1.4-0.2-1.5l-0.2 0.1z"
                                />
                                <path
                                    d="m37.1 7.2c-0.2-0.3-3.5-4.5-6.4-5.4-0.9-0.3-2-0.4-3.1-0.5-0.6 0-1.2-0.2-1.8-0.2-0.4 0-0.9-0.2-1.3-0.2-1.1-0.2-2.2-0.4-3.2-0.4s-0.4 0-0.6 0c-1.4 0.1-2.9 0.9-4.4 1.7-0.4 0.2-0.9 0.5-1.3 0.7-0.3 0.2-0.6 0.3-0.9 0.4-2.3 1.1-4.3 2.1-6.7 2.8v-1.4c0-0.4-0.4-0.8-0.8-0.8h-5.3c-0.4 0-0.8 0.4-0.8 0.8v10.9c0 0.4 0.4 0.8 0.8 0.8h5.3c0.4 0 0.8-0.4 0.8-0.8v-1.2c2 0.6 4.2 1.2 6.7 1.2s0.5 0 0.8 0c1.8 0 3.3-0.8 4.7-1.4 0.8-0.4 1.6-0.7 2.3-0.9 1-0.3 2.3-0.4 3.6-0.4 2.9-0.2 5.5-0.4 5.7-2.4 0-0.7 0-1.2-0.4-1.6-0.5-0.5-1.3-0.8-2.7-0.8s-1.9 0-2.8 0.2c-0.9 0-1.9 0.2-2.8 0.2s-1.3 0-1.7-0.2h-0.2l0.2-0.1c1.6-0.6 3.8-1.4 6.1-1.4s2.6 0.2 3.9 0.7c0.7 0.3 1.4 0.7 2.1 1.2 1.1 0.7 2.2 1.4 3.2 1.4s0.7-0.1 1-0.3c0.6-0.4 0.4-1.8 0-2.6zm-30.3 8.4s0 0.1-0.1 0.1h-5.4s-0.1 0-0.1-0.1v-11s0-0.1 0.1-0.1h5.3s0.1 0 0.1 0.1v11h0.1zm29.9-6.5c-0.2 0.1-0.4 0.2-0.6 0.2-0.8 0-1.8-0.7-2.8-1.3-0.7-0.5-1.5-1-2.2-1.2-1.4-0.5-2.7-0.8-4.2-0.8-2.4 0-4.7 0.8-6.4 1.4l-1.2 0.5c-0.2 0-0.3 0.2-0.2 0.4 0 0.2 0.1 0.3 0.3 0.4l1.2 0.4c0.5 0.2 1.2 0.2 1.9 0.2s1.9 0 2.8-0.2c0.9 0 1.9-0.2 2.7-0.2s1.9 0.2 2.2 0.5c0.2 0.2 0.3 0.5 0.2 1-0.1 1.3-2.5 1.5-5 1.7-1.3 0-2.6 0.2-3.7 0.5-0.8 0.2-1.6 0.6-2.5 1-1.3 0.6-2.7 1.3-4.4 1.4h-0.7c-2.4 0-4.7-0.6-6.7-1.2v-7c2.6-0.7 4.7-1.7 7-2.9 0.3-0.2 0.6-0.3 0.9-0.4 0.4-0.2 0.9-0.5 1.3-0.7 1.4-0.7 2.9-1.5 4.1-1.6h0.5c0.9 0 2 0.2 3 0.4 0.5 0 0.9 0.2 1.4 0.2 0.6 0 1.2 0.2 1.8 0.2 1.1 0.1 2.2 0.3 3 0.5 2.5 0.8 5.7 4.7 5.9 5 0.3 0.6 0.3 1.4 0.2 1.5l0.2 0.1z"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_revenue_efapax | seprator }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ'"
                        :class="{
                            active: revenuesFilter == 'ΑΛΛΗ',
                            empty: !total_revenue_other,
                        }"
                        @click="
                            revenuesFilter == 'ΑΛΛΗ'
                                ? (revenuesFilter = null)
                                : (revenuesFilter = 'ΑΛΛΗ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="54.051"
                                height="50.886"
                                viewBox="0 0 54.051 50.886"
                            >
                                <g
                                    id="Group_3600"
                                    data-name="Group 3600"
                                    transform="translate(-955.164 -629.514)"
                                >
                                    <path
                                        id="Path_6343"
                                        data-name="Path 6343"
                                        d="M994.564,645.655a12.826,12.826,0,1,0-24.75,0l-14.65,7.707v18.424a8.613,8.613,0,0,0,8.613,8.613H1000.6a8.614,8.614,0,0,0,8.614-8.613V653.363Zm-12.375-14.141a10.826,10.826,0,1,1-10.826,10.825A10.837,10.837,0,0,1,982.189,631.514ZM970.5,647.6a12.807,12.807,0,0,0,23.384-.023l12.731,6.685-17.94,10.155-2.782-1.294a8.765,8.765,0,0,0-7.412,0l-2.9,1.35-17.83-10.206Zm-13.338,24.191v-16.71l17.309,9.908-17.2,8A6.576,6.576,0,0,1,957.164,671.787ZM1000.6,678.4H963.777a6.618,6.618,0,0,1-6.236-4.433l21.364-9.942a7.776,7.776,0,0,1,6.568,0l21.365,9.941A6.62,6.62,0,0,1,1000.6,678.4Zm6.614-6.613a6.584,6.584,0,0,1-.115,1.2l-17.308-8.054,17.423-9.862Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6344"
                                        data-name="Path 6344"
                                        d="M983.14,649.71a7.5,7.5,0,0,0,5.2-2.081.753.753,0,0,0-1.04-1.09,6.024,6.024,0,0,1-9.776-2.186H982.3a.753.753,0,0,0,0-1.506H977.15a6.206,6.206,0,0,1-.039-.672,5.905,5.905,0,0,1,.065-.836h7.889a.753.753,0,0,0,0-1.506h-7.481a6.029,6.029,0,0,1,9.82-1.921.753.753,0,0,0,1.065-1.065,7.531,7.531,0,0,0-12.487,2.986h-1.54a.753.753,0,0,0,0,1.506h1.212a7.446,7.446,0,0,0-.05.836c0,.227.015.45.035.672h-1.2a.753.753,0,0,0,0,1.506h1.487A7.545,7.545,0,0,0,983.14,649.71Z"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_revenue_other }}
                        </div>
                    </div>
                </div>

                <table v-if="revenues.length">
                    <tr>
                        <th>Είδος / Προέλευση</th>
                        <th>Ποσό</th>
                    </tr>
                    <tr
                        v-for="revenue in revenues"
                        v-bind:key="'revenue_item' + revenue.id"
                    >
                        <td>{{ revenue.source | revenuesValue }}</td>
                        <td class="right bold">
                            € {{ revenue.amount | seprator }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="card stocks" id="stocks">
            <h3 class="card__title">ΕΠΕΝΔΥΤΙΚΑ ΠΡΟΪΟΝΤΑ</h3>
            <div class="card__table">
                <div class="card__table__head">
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΣΥΝΟΛΟ ΕΠΕΝΔΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ'"
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="Group_3575"
                                data-name="Group 3575"
                                xmlns="http://www.w3.org/2000/svg"
                                width="63.148"
                                height="53.619"
                                viewBox="0 0 63.148 53.619"
                            >
                                <path
                                    id="Path_6315"
                                    data-name="Path 6315"
                                    d="M1029.9,981.807c-1.685,0-3.573,1.237-5.408,2.437a20.276,20.276,0,0,1-3.455,1.965,18.037,18.037,0,0,1-6.6,1.235,29.08,29.08,0,0,1-10.346-2.306l-.278-.107.285-.087a10.179,10.179,0,0,1,2.907-.337c1.432,0,3.072.156,4.665.306s3.259.313,4.74.313c2.347,0,3.811-.41,4.61-1.288a3.255,3.255,0,0,0,.681-2.635c-.327-3.367-4.86-3.671-9.664-3.993a35.714,35.714,0,0,1-6.06-.738,22.558,22.558,0,0,1-3.906-1.58,20.142,20.142,0,0,0-7.859-2.435c-.425-.021-.861-.033-1.3-.033a40.3,40.3,0,0,0-11.267,1.941v-2.027a1.355,1.355,0,0,0-1.354-1.354h-9.007a1.356,1.356,0,0,0-1.355,1.354v18.511a1.356,1.356,0,0,0,1.355,1.355h9.007a1.355,1.355,0,0,0,1.354-1.355v-2.305a64.446,64.446,0,0,1,11.333,4.66l1.546.753c.736.357,1.5.754,2.237,1.137,2.5,1.3,5.086,2.647,7.37,2.87a9.325,9.325,0,0,0,.946.045,29.937,29.937,0,0,0,5.335-.705c.749-.144,1.524-.292,2.264-.41,1-.158,2.007-.288,2.986-.413a36.008,36.008,0,0,0,5.3-.923c4.835-1.437,10.378-8.439,10.723-9.018.7-1.191,1-3.57-.052-4.293A2.972,2.972,0,0,0,1029.9,981.807Zm-49.387,9.142a.22.22,0,0,1-.219.22h-9.007a.22.22,0,0,1-.22-.22V972.437a.22.22,0,0,1,.22-.219h9.007a.219.219,0,0,1,.219.219Zm50.064-4.973c-.32.521-5.693,7.166-9.977,8.438a35.415,35.415,0,0,1-5.1.881c-.94.12-2.006.257-3.022.418-.754.12-1.543.27-2.305.417a29.053,29.053,0,0,1-5.09.681c-.288,0-.563-.012-.818-.037-2.034-.2-4.506-1.487-6.9-2.731-.75-.389-1.524-.792-2.27-1.153-.524-.254-1.038-.5-1.557-.757a63.845,63.845,0,0,0-11.85-4.828c-.014,0-.026,0-.04,0V975.8c.019,0,.037,0,.056,0a39.976,39.976,0,0,1,11.212-1.977c.413,0,.826.01,1.228.031a19.1,19.1,0,0,1,7.369,2.311,23.318,23.318,0,0,0,4.141,1.664,36.536,36.536,0,0,0,6.3.777c4.235.284,8.236.553,8.458,2.823a2.078,2.078,0,0,1-.352,1.639c-.52.572-1.748.862-3.65.862-1.419,0-3.044-.156-4.623-.307-1.616-.154-3.288-.313-4.782-.313a11.412,11.412,0,0,0-3.285.394l-2.082.633a.649.649,0,0,0-.046,1.226l2.029.787a30.29,30.29,0,0,0,10.816,2.395,19.317,19.317,0,0,0,7.068-1.322,21.176,21.176,0,0,0,3.708-2.1c1.666-1.091,3.39-2.219,4.689-2.219a1.684,1.684,0,0,1,.987.3A3.268,3.268,0,0,1,1030.573,985.976Z"
                                    transform="translate(-969.928 -944.49)"
                                    fill="#212125"
                                />
                                <path
                                    id="Path_6316"
                                    data-name="Path 6316"
                                    d="M1020.11,947.654a.912.912,0,0,0-.007,1.824l6.515.049L1011.641,964.5l-6.37-6.369a1.134,1.134,0,0,0-1.6,0L992.3,969.5a1.135,1.135,0,1,0,1.6,1.606l10.559-10.559,6.37,6.368a1.133,1.133,0,0,0,1.6,0l15.781-15.782.05,6.508a.912.912,0,0,0,1.824-.007v-9.978Z"
                                    transform="translate(-966.951 -947.654)"
                                    fill="#212125"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_stocks | seprator }}
                        </div>
                    </div>
                </div>

                <table v-if="stocks.length">
                    <tr>
                        <th>Είδος προϊόντος</th>
                        <!-- <th>Τίτλος προϊόντος</th> -->
                        <th>Αποτίμηση</th>
                        <!-- <th>Ποσότητα</th>
            <th>Κατάσταση/Μεταβολή</th> -->
                    </tr>
                    <tr
                        v-for="stock in stocks"
                        v-bind:key="'stock_item' + stock.id"
                        v-if="stock.row != '-'"
                    >
                        <td>{{ stock.row | stocksValue }}</td>
                        <!-- <td>BNP PARIBAS INSTICASH - USD MONEY MARKET	</td> -->
                        <td class="right bold">
                            ({{
                                stock.currency == "ΕΥΡΩ" ? "€" : stock.currency
                            }}) {{ stock.cost | seprator }}
                        </td>
                        <!-- <td>ΑΠΟΚΤΗΣΗ ΣΕ ΠΡΟΗΓΟΥΜΕΝΗ ΧΡΗΣΗ	</td> -->
                    </tr>
                </table>
            </div>
        </div>

        <div class="card deposits" id="deposits">
            <h3 class="card__title">ΚΑΤΑΘΕΣΕΙΣ</h3>
            <div class="card__table">
                <div class="card__table__head">
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΣΥΝΟΛΟ ΚΑΤΑΘΕΣΕΩΝ'"
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΚΑΤΑΘΕΣΕΙΣ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="47"
                                height="59.832"
                                viewBox="0 0 47 59.832"
                            >
                                <path
                                    id="Path_6284"
                                    data-name="Path 6284"
                                    d="M1106,767.454a7.892,7.892,0,0,1,5.616,2.327,1.153,1.153,0,1,0,1.63-1.631,10.242,10.242,0,0,0-16.948,3.963h-1.961a1.153,1.153,0,1,0,0,2.305h1.465c-.034.342-.05.663-.05.979,0,.255.013.506.033.758h-1.448a1.153,1.153,0,1,0,0,2.306h1.887a10.321,10.321,0,0,0,9.776,7.184,10.2,10.2,0,0,0,7.07-2.83,1.153,1.153,0,1,0-1.589-1.67,7.916,7.916,0,0,1-5.481,2.194,8,8,0,0,1-7.318-4.878h6.187a1.153,1.153,0,1,0,0-2.306h-6.771a7.492,7.492,0,0,1-.041-.758,7.713,7.713,0,0,1,.07-.979h10.454a1.153,1.153,0,1,0,0-2.305h-9.813A7.941,7.941,0,0,1,1106,767.454Z"
                                    transform="translate(-1080.836 -735.851)"
                                />
                                <path
                                    id="Path_6285"
                                    data-name="Path 6285"
                                    d="M1123.974,776.472c0-.009-.005-.094-.006-.1-2.145-22.969-13.917-27.383-17.473-28.188a.472.472,0,0,1-.359-.461v-7.6a.475.475,0,0,1,.05-.212l4.242-8.483a1.324,1.324,0,0,0-1.511-1.877l-4.59,1.164a.474.474,0,0,1-.438-.11l-2.5-2.286a1.319,1.319,0,0,0-1.789,0l-2.5,2.286a.472.472,0,0,1-.438.11l-4.59-1.164a1.324,1.324,0,0,0-1.511,1.877l4.241,8.482a.474.474,0,0,1,.051.213v7.6a.472.472,0,0,1-.359.461c-3.557.805-15.328,5.219-17.474,28.188,0,.01-.006.1-.006.106l-.008.144c-.259,4.087,1.2,6.552,2.463,7.9,2.037,2.172,5.22,3.273,9.457,3.273h21.505c4.594,0,8.119-1.223,10.479-3.632A11.335,11.335,0,0,0,1123.974,776.472ZM1095.7,747.72v-3h4.793a.425.425,0,0,0,0-.85H1095.7v-3.327h9.586v7.5H1095.7Zm-4.382-16.679a.477.477,0,0,1,.42-.69.525.525,0,0,1,.123.016l4.59,1.164a1.311,1.311,0,0,0,1.222-.306l2.5-2.287a.472.472,0,0,1,.642,0l2.5,2.287a1.313,1.313,0,0,0,1.222.306l4.59-1.164a.476.476,0,0,1,.543.674l-4.241,8.482a1.278,1.278,0,0,0-.062.169h-9.744a1.263,1.263,0,0,0-.061-.168Zm28.984,52.526c-2.2,2.241-5.516,3.377-9.872,3.377h-21.505c-3.993,0-6.966-1.011-8.839-3-1.151-1.228-2.473-3.483-2.234-7.266l.012-.226c2.091-22.4,13.4-26.665,16.814-27.439a1.308,1.308,0,0,0,.4-.167.414.414,0,0,0,.193.052h10.436a.414.414,0,0,0,.193-.052,1.308,1.308,0,0,0,.4.167c3.415.775,14.723,5.04,16.817,27.485A10.424,10.424,0,0,1,1120.3,783.567Z"
                                    transform="translate(-1076.974 -727.962)"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_deposits | seprator }}
                        </div>
                    </div>
                </div>

                <table v-if="deposits.length">
                    <tr>
                        <th>Είδος / Προέλευση</th>
                        <th>Τύπος</th>
                        <th>Πλήθος δικαιούχων λογαριασμού</th>
                        <th>Ίδρυμα</th>
                        <th>Χώρα</th>
                        <th>Ποσό</th>
                    </tr>
                    <tr
                        v-for="deposit in deposits"
                        v-bind:key="'deposits_item' + deposit.id"
                    >
                        <td>{{ deposit.from }}</td>
                        <td>{{ deposit.row | depositsValue }}</td>
                        <td>{{ deposit.beneficiaries }}</td>
                        <td>{{ deposit.idrima }}</td>
                        <td>{{ deposit.country }}</td>
                        <td class="right bold">
                            ({{
                                deposit.currency == "ΕΥΡΩ"
                                    ? "€"
                                    : deposit.currency
                            }}) {{ deposit.cost | seprator }}
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="card loans" id="loans">
            <h3 class="card__title">Δανειακες υποχρεωσεις και οφειλες</h3>
            <div class="card__table">
                <div class="card__table__head">
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΟΦΕΙΛΕΣ ΔΑΝΕΙΩΝ'"
                    >
                        <div class="card__table__head__item__icon">
                            <img src="/images/loans_icon.svg" alt="" />
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_loans | seprator }}
                        </div>
                    </div>
                </div>

                <table v-if="loans.length">
                    <tr>
                        <th>Πιστωτής</th>
                        <th>Αρχικό Ποσό</th>
                        <th>Οφειλόμενο Ποσό</th>
                        <th>Ημ/νία Δημιουργίας</th>
                        <th>Ημ/νία Λήξης</th>
                    </tr>
                    <tr
                        v-for="loan in loans"
                        v-bind:key="'loans_item' + loan.id"
                    >
                        <td>{{ loan.from }}</td>
                        <td>
                            ({{ loan.currency == "ΕΥΡΩ" ? "€" : loan.initial }})
                            {{ loan.initial | seprator }}
                        </td>
                        <td class="right bold">
                            ({{
                                loan.currency == "ΕΥΡΩ" ? "€" : loan.currency
                            }}) {{ loan.actual | seprator }}
                        </td>
                        <td>{{ loan.from_date | formatDate }}</td>
                        <td>{{ loan.to_date | formatDate }}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="card companies" id="companies">
            <h3 class="card__title">Συμμετοχη σε επιχειρησεις</h3>
            <div class="card__table">
                <div class="card__table__head">
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΚΕΦΑΛΑΙΟ ΕΠΙΧΕΙΡΗΣΕΩΝ'"
                    >
                        <div class="card__table__head__item__icon">
                            <img src="/images/company_icon.svg" alt="" />
                        </div>
                        <div class="card__table__head__item__text">
                            € {{ total_companies | seprator }}
                        </div>
                    </div>
                </div>

                <table v-if="companies.length">
                    <tr>
                        <th>Επωνυμία</th>
                        <th>Είδος Συμμετοχής</th>
                        <th>Είδος Επιχείρησης</th>
                        <th>Κεφάλαιο εισφοράς</th>
                        <th>Έτος έναρξης</th>
                    </tr>
                    <tr
                        v-for="company in companies"
                        v-bind:key="'company_item' + company.id"
                        v-if="
                            company.name != '-' &&
                            company.name != '' &&
                            company.cost != 0
                        "
                    >
                        <td>{{ company.name }}</td>
                        <td>{{ company.type | companiesValue }}</td>
                        <td>{{ company.company_type }}</td>
                        <td class="right bold">
                            (€) {{ company.cost | seprator }}
                        </td>
                        <td>{{ company.year }}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="card properties" id="properties">
            <h3 class="card__title">Ακινητα</h3>
            <div class="card__table">
                <div class="card__table__head">
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΚΑΤΑΣΤΗΜΑΤΑ'"
                        :class="{
                            active: propertiesFilter == 'ΚΑΤΑΣΤΗΜΑ',
                            empty: !total_katastimata,
                        }"
                        @click="
                            propertiesFilter == 'ΚΑΤΑΣΤΗΜΑ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΚΑΤΑΣΤΗΜΑ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΚΑΤΑΣΤΗΜΑ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="57.996"
                                height="42.003"
                                viewBox="0 0 57.996 42.003"
                            >
                                <g
                                    id="Group_3443"
                                    data-name="Group 3443"
                                    transform="translate(-29.255 -336.974)"
                                >
                                    <path
                                        id="Path_6272"
                                        data-name="Path 6272"
                                        d="M59.193,358.363H41.335a.5.5,0,0,0-.5.5v12.425a.5.5,0,0,0,.5.5H59.193a.5.5,0,0,0,.5-.5V358.863A.5.5,0,0,0,59.193,358.363Zm-.5,12.425H41.835V359.363H58.693Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6273"
                                        data-name="Path 6273"
                                        d="M87.207,352.677l-4.576-14.995c0-.017-.018-.028-.024-.044a.819.819,0,0,0-.336-.446,1.01,1.01,0,0,0-.173-.117,1.086,1.086,0,0,0-.153-.046.884.884,0,0,0-.222-.045c-.017,0-.031-.01-.048-.01H35.1c-.016,0-.029.008-.045.009a.975.975,0,0,0-.2.04.6.6,0,0,0-.33.154,1.014,1.014,0,0,0-.154.121,2.387,2.387,0,0,0-.2.332c-.005.013-.016.023-.02.037l-4.808,14.855a.979.979,0,0,0-.084.484.99.99,0,0,0,.683.914.97.97,0,0,0,.307.049.992.992,0,0,0,.634-.238,13.9,13.9,0,0,1,4.052-1.176.994.994,0,0,0-.093.411v25.011a1,1,0,0,0,1,1H80.825a1,1,0,0,0,1-1V352.966a.986.986,0,0,0-.071-.348,13.843,13.843,0,0,1,3.971,1.241.991.991,0,0,0,.449.107c.011,0,.021,0,.032,0s.03.007.045.007a.954.954,0,0,0,.292-.044A1,1,0,0,0,87.207,352.677Zm-28.327-13.7h10.8l1.866,12.617a16.8,16.8,0,0,0-12.779.061Zm-1,0-.118,12.663a17.273,17.273,0,0,0-12.786.011l2.11-12.674ZM31.872,351.2l3.957-12.229H46.072l-2.14,12.857A17.3,17.3,0,0,0,31.872,351.2Zm42.849,25.774h-8V359.363h8Zm5.1-24.011v24.011h-4.1V358.863a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5v18.114H36.842V352.966a.977.977,0,0,0-.189-.554,14.652,14.652,0,0,1,6.945,1.446.948.948,0,0,0,.814.031.973.973,0,0,0,.566-.079,15.112,15.112,0,0,1,12.9.048.988.988,0,0,0,.451.108,1,1,0,0,0,.626-.23,15.3,15.3,0,0,1,12.809.123.987.987,0,0,0,1-.059A14.877,14.877,0,0,1,80,352.43.97.97,0,0,0,79.825,352.966Zm-7.255-1.247-1.886-12.745H80.935l3.756,12.307A17.517,17.517,0,0,0,72.57,351.719Z"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_katastimata }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΟΙΚΟΠΕΔΟ'"
                        :class="{
                            active: propertiesFilter == 'ΟΙΚΟΠΕΔΟ',
                            empty: !total_oikopeda,
                        }"
                        @click="
                            propertiesFilter == 'ΟΙΚΟΠΕΔΟ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΟΙΚΟΠΕΔΟ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="60"
                                height="60"
                                viewBox="0 0 60 60"
                            >
                                <path
                                    fill="#333"
                                    d="M19.63,42.47h21.5a.5.5,0,0,0,.5-.5V27.65L45,30.2a.5.5,0,0,0,.61-.79L30.68,18a.5.5,0,0,0-.6,0l-15,11.06a.5.5,0,0,0,.59.8l3.47-2.56V42A.5.5,0,0,0,19.63,42.47ZM30.38,19l10.26,7.85V41.47H20.13V26.58Z"
                                />
                                <path
                                    fill="#333"
                                    d="M6,1.5a1,1,0,0,0-1,1V5H2.5a1,1,0,0,0,0,2H6A1,1,0,0,0,7,6V2.5A1,1,0,0,0,6,1.5Z"
                                />
                                <path
                                    fill="#333"
                                    d="M6,11.86a1,1,0,0,0-1,1v6.86a1,1,0,0,0,2,0V12.86A1,1,0,0,0,6,11.86Z"
                                />
                                <path
                                    fill="#333"
                                    d="M6,25.57a1,1,0,0,0-1,1v6.86a1,1,0,0,0,2,0V26.57A1,1,0,0,0,6,25.57Z"
                                />
                                <path
                                    fill="#333"
                                    d="M6,39.29a1,1,0,0,0-1,1v6.86a1,1,0,0,0,2,0V40.29A1,1,0,0,0,6,39.29Z"
                                />
                                <path
                                    fill="#333"
                                    d="M54,34.43a1,1,0,0,0,1-1V26.57a1,1,0,0,0-2,0v6.86A1,1,0,0,0,54,34.43Z"
                                />
                                <path
                                    fill="#333"
                                    d="M54,48.14a1,1,0,0,0,1-1V40.29a1,1,0,0,0-2,0v6.86A1,1,0,0,0,54,48.14Z"
                                />
                                <path
                                    fill="#333"
                                    d="M54,20.71a1,1,0,0,0,1-1V12.86a1,1,0,1,0-2,0v6.86A1,1,0,0,0,54,20.71Z"
                                />
                                <path
                                    fill="#333"
                                    d="M47.14,5H40.29a1,1,0,0,0,0,2h6.86a1,1,0,0,0,0-2Z"
                                />
                                <path
                                    fill="#333"
                                    d="M26.57,7h6.86a1,1,0,0,0,0-2H26.57a1,1,0,1,0,0,2Z"
                                />
                                <path
                                    fill="#333"
                                    d="M12.86,7h6.86a1,1,0,0,0,0-2H12.86a1,1,0,0,0,0,2Z"
                                />
                                <path
                                    fill="#333"
                                    d="M54,7h3.5a1,1,0,0,0,0-2H55V2.5a1,1,0,0,0-2,0V6A1,1,0,0,0,54,7Z"
                                />
                                <path
                                    fill="#333"
                                    d="M6,53H2.5a1,1,0,0,0,0,2H5v2.5a1,1,0,0,0,2,0V54A1,1,0,0,0,6,53Z"
                                />
                                <path
                                    fill="#333"
                                    d="M19.71,53H12.86a1,1,0,0,0,0,2h6.86a1,1,0,0,0,0-2Z"
                                />
                                <path
                                    fill="#333"
                                    d="M47.14,53H40.29a1,1,0,0,0,0,2h6.86a1,1,0,0,0,0-2Z"
                                />
                                <path
                                    fill="#333"
                                    d="M33.43,53H26.57a1,1,0,1,0,0,2h6.86a1,1,0,0,0,0-2Z"
                                />
                                <path
                                    fill="#333"
                                    d="M57.5,53H54a1,1,0,0,0-1,1v3.5a1,1,0,0,0,2,0V55h2.5a1,1,0,0,0,0-2Z"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_oikopeda }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΑΠΟΘΗΚΕΣ'"
                        :class="{
                            active: propertiesFilter == 'ΑΠΟΘΗΚΗ',
                            empty: !total_apothikes,
                        }"
                        @click="
                            propertiesFilter == 'ΑΠΟΘΗΚΗ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΑΠΟΘΗΚΗ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΑΠΟΘΗΚΗ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="57.817"
                                height="35.98"
                                viewBox="0 0 57.817 35.98"
                            >
                                <path
                                    id="Path_6277"
                                    data-name="Path 6277"
                                    d="M76.808,862.9,49.025,851.128a.992.992,0,0,0-.766-.005l-22.641,9.228h0l-5.391,2.2a1,1,0,0,0,.754,1.851l4.028-1.641v23.27a1,1,0,0,0,1,1H71.268a1,1,0,0,0,1-1V863.145l3.761,1.592a1,1,0,1,0,.779-1.841Zm-14,13.6H34.217v-3H62.8Zm-28.586,1H62.8v3H34.217Zm28.586-5H34.217v-3.509H62.8ZM34.217,881.5H62.8v3.525H34.217Zm36.051,3.525H63.8V868.987a1,1,0,0,0-1-1H34.217a1,1,0,0,0-1,1v16.042H27.006V861.944l21.622-8.812,21.64,9.165Z"
                                    transform="translate(-19.602 -851.049)"
                                    fill="#212125"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_apothikes }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΟΙΚΙΕΣ'"
                        :class="{ active: propertiesFilter == 'ΟΙΚΙΑ' }"
                        @click="
                            propertiesFilter == 'ΟΙΚΙΑ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΟΙΚΙΑ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΟΙΚΙΑ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="57.818"
                                height="45.973"
                                viewBox="0 0 57.818 45.973"
                            >
                                <path
                                    id="Path_6258"
                                    data-name="Path 6258"
                                    d="M87.148,245.02l-8.92-6.827v-9.006a1,1,0,0,0-2,0v7.475L59.365,223.756a1,1,0,0,0-1.2-.012L30.131,244.39A1,1,0,0,0,31.316,246l7.975-5.873v28.394a1,1,0,0,0,1,1H77.228a1,1,0,0,0,1-1V240.71l7.705,5.9a1,1,0,1,0,1.215-1.587Zm-23.974,22.5H54.091V245.813h9.083Zm13.054,0H64.174V245.813a1,1,0,0,0-1-1H54.091a1,1,0,0,0-1,1v21.709h-11.8v-28.2a.974.974,0,0,0-.18-.539L58.746,225.8l17.482,13.38Z"
                                    transform="translate(-29.723 -223.549)"
                                    fill="#212125"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_oikies }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΔΙΑΜΕΡΙΣΜΑΤΑ'"
                        :class="{
                            active: propertiesFilter == 'ΔΙΑΜΕΡΙΣΜΑ',
                            empty: !total_diamerismata,
                        }"
                        @click="
                            propertiesFilter == 'ΔΙΑΜΕΡΙΣΜΑ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΔΙΑΜΕΡΙΣΜΑ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΔΙΑΜΕΡΙΣΜΑ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="57.294"
                                height="42.12"
                                viewBox="0 0 57.294 42.12"
                            >
                                <g
                                    id="Group_3442"
                                    data-name="Group 3442"
                                    transform="translate(-27.354 -436.805)"
                                >
                                    <path
                                        id="Path_6259"
                                        data-name="Path 6259"
                                        d="M83.648,436.8H53.7a1,1,0,0,0-1,1v9.343H33.461a1,1,0,0,0-1,1V454.3H27.854a.5.5,0,0,0,0,1h4.607v5.242H27.854a.5.5,0,0,0,0,1h4.607v5.243H27.854a.5.5,0,0,0,0,1h4.607v10.145a1,1,0,0,0,1,1H83.648a1,1,0,0,0,1-1V437.8A1,1,0,0,0,83.648,436.8ZM34.461,449.148H52.7V454.3H34.461Zm0,6.147H52.7v5.242H34.461Zm0,6.242H52.7v5.243H34.461Zm0,6.243H52.7v9.145H34.461Zm48.187,9.145H54.7V438.8H82.648Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6260"
                                        data-name="Path 6260"
                                        d="M59.987,447.967a1,1,0,0,0,1-1v-2.843a1,1,0,0,0-2,0v2.843A1,1,0,0,0,59.987,447.967Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6261"
                                        data-name="Path 6261"
                                        d="M68.675,447.967a1,1,0,0,0,1-1v-2.843a1,1,0,0,0-2,0v2.843A1,1,0,0,0,68.675,447.967Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6262"
                                        data-name="Path 6262"
                                        d="M77.361,447.967a1,1,0,0,0,1-1v-2.843a1,1,0,0,0-2,0v2.843A1,1,0,0,0,77.361,447.967Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6263"
                                        data-name="Path 6263"
                                        d="M59.987,455.467a1,1,0,0,0,1-1v-2.844a1,1,0,0,0-2,0v2.844A1,1,0,0,0,59.987,455.467Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6264"
                                        data-name="Path 6264"
                                        d="M68.675,455.467a1,1,0,0,0,1-1v-2.844a1,1,0,1,0-2,0v2.844A1,1,0,0,0,68.675,455.467Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6265"
                                        data-name="Path 6265"
                                        d="M77.361,455.467a1,1,0,0,0,1-1v-2.844a1,1,0,1,0-2,0v2.844A1,1,0,0,0,77.361,455.467Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6266"
                                        data-name="Path 6266"
                                        d="M59.987,462.967a1,1,0,0,0,1-1v-2.844a1,1,0,1,0-2,0v2.844A1,1,0,0,0,59.987,462.967Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6267"
                                        data-name="Path 6267"
                                        d="M68.675,462.967a1,1,0,0,0,1-1v-2.844a1,1,0,1,0-2,0v2.844A1,1,0,0,0,68.675,462.967Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6268"
                                        data-name="Path 6268"
                                        d="M77.361,462.967a1,1,0,0,0,1-1v-2.844a1,1,0,1,0-2,0v2.844A1,1,0,0,0,77.361,462.967Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6269"
                                        data-name="Path 6269"
                                        d="M59.987,470.467a1,1,0,0,0,1-1v-2.844a1,1,0,1,0-2,0v2.844A1,1,0,0,0,59.987,470.467Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6270"
                                        data-name="Path 6270"
                                        d="M68.675,470.467a1,1,0,0,0,1-1v-2.844a1,1,0,1,0-2,0v2.844A1,1,0,0,0,68.675,470.467Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6271"
                                        data-name="Path 6271"
                                        d="M77.361,470.467a1,1,0,0,0,1-1v-2.844a1,1,0,1,0-2,0v2.844A1,1,0,0,0,77.361,470.467Z"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_diamerismata }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΑΓΡΟΤΕΜΑΧΙΑ'"
                        :class="{
                            active: propertiesFilter == 'ΑΓΡΟΤΕΜΑΧΙΟ',
                            empty: !total_agrotemaxia,
                        }"
                        @click="
                            propertiesFilter == 'ΑΓΡΟΤΕΜΑΧΙΟ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΑΓΡΟΤΕΜΑΧΙΟ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="47.66"
                                height="48.27"
                                viewBox="0 0 47.66 48.27"
                            >
                                <title>agrotemaxia</title>
                                <g id="Layer_2" data-name="Layer 2">
                                    <g id="FILL">
                                        <path
                                            d="M46.79,38.61H40.51V.87a.87.87,0,1,0-1.73,0V7.34a17.89,17.89,0,0,1-7.24,1.57c-2.73,0-6.93-1.16-11-2.27S11.93,4.33,9,4.33A14.65,14.65,0,0,0,.31,7.21.87.87,0,1,0,1.42,8.54,13.16,13.16,0,0,1,7.27,6.18V46.89a.87.87,0,1,0,1.73,0V40.34H46.79a.87.87,0,1,0,0-1.73Zm-8,0H36V10.11a19.71,19.71,0,0,0,2.8-.87ZM35.09,10.27V38.61H31.52v-28h0A18.56,18.56,0,0,0,35.09,10.27ZM26.94,10a27.24,27.24,0,0,0,3.68.55v28H27Zm-.86,28.59H22.42V9c1.26.33,2.5.65,3.68.91ZM21.55,8.73V38.61H17.87V7.74L20,8.33ZM13.37,6.64c1.16.25,2.38.54,3.64.87v31.1H13.37Zm-.87,32H9V6.06a20.17,20.17,0,0,1,3.46.41Z"
                                        />
                                        <path
                                            d="M14.2,42.51a.43.43,0,0,0-.43.43v4.9a.43.43,0,1,0,.86,0v-4.9A.43.43,0,0,0,14.2,42.51Z"
                                        />
                                        <path
                                            d="M19.61,42.51a.43.43,0,0,0-.43.43v4.9a.43.43,0,0,0,.43.43.44.44,0,0,0,.44-.43v-4.9A.44.44,0,0,0,19.61,42.51Z"
                                        />
                                        <path
                                            d="M25,42.51a.43.43,0,0,0-.43.43v4.9a.43.43,0,0,0,.86,0v-4.9A.43.43,0,0,0,25,42.51Z"
                                        />
                                        <path
                                            d="M30.44,42.51a.43.43,0,0,0-.43.43v4.9a.43.43,0,0,0,.43.43.44.44,0,0,0,.44-.43v-4.9A.44.44,0,0,0,30.44,42.51Z"
                                        />
                                        <path
                                            d="M35.86,42.51a.44.44,0,0,0-.44.43v4.9a.44.44,0,0,0,.44.43.43.43,0,0,0,.43-.43v-4.9A.43.43,0,0,0,35.86,42.51Z"
                                        />
                                        <path
                                            d="M41.27,42.51a.43.43,0,0,0-.43.43v4.9a.43.43,0,1,0,.86,0v-4.9A.43.43,0,0,0,41.27,42.51Z"
                                        />
                                        <path
                                            d="M6.4,3a.44.44,0,0,0,.44-.44V.49A.44.44,0,0,0,6.4.06.43.43,0,0,0,6,.49V2.56A.44.44,0,0,0,6.4,3Z"
                                        />
                                        <path
                                            d="M11.82,2.36a.44.44,0,0,0,.43-.44V.49a.43.43,0,0,0-.43-.43.44.44,0,0,0-.44.43V1.92A.44.44,0,0,0,11.82,2.36Z"
                                        />
                                        <path
                                            d="M17.23,3.78a.44.44,0,0,0,.43-.44V.49a.43.43,0,1,0-.86,0V3.34A.44.44,0,0,0,17.23,3.78Z"
                                        />
                                        <path
                                            d="M22.65,5.08a.44.44,0,0,0,.43-.44V.49a.43.43,0,0,0-.43-.43.44.44,0,0,0-.44.43V4.63a.44.44,0,0,0,.42.45Z"
                                        />
                                        <path
                                            d="M28.06,6.64a.44.44,0,0,0,.43-.44V.49a.43.43,0,1,0-.86,0V6.2A.44.44,0,0,0,28.06,6.64Z"
                                        />
                                        <path
                                            d="M33.47,7.16a.44.44,0,0,0,.44-.43V.49a.44.44,0,0,0-.87,0V6.73A.43.43,0,0,0,33.47,7.16Z"
                                        />
                                        <path
                                            d="M4.53,13.57H.69a.43.43,0,1,0,0,.86H4.53a.43.43,0,1,0,0-.86Z"
                                        />
                                        <path
                                            d="M4.53,19H.69a.43.43,0,0,0-.43.43.44.44,0,0,0,.43.44H4.53A.44.44,0,0,0,5,19.41.43.43,0,0,0,4.53,19Z"
                                        />
                                        <path
                                            d="M4.53,24.39H.69a.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43H4.53A.43.43,0,0,0,5,24.83.44.44,0,0,0,4.53,24.39Z"
                                        />
                                        <path
                                            d="M4.53,29.81H.69a.43.43,0,0,0-.43.43.44.44,0,0,0,.43.44H4.53A.44.44,0,0,0,5,30.24.43.43,0,0,0,4.53,29.81Z"
                                        />
                                        <path
                                            d="M4.53,35.22H.69a.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43H4.53A.43.43,0,0,0,5,35.66.44.44,0,0,0,4.53,35.22Z"
                                        />
                                        <path
                                            d="M4.53,40.64H.69a.43.43,0,1,0,0,.86H4.53a.43.43,0,1,0,0-.86Z"
                                        />
                                        <path
                                            d="M43.11,6.35H47a.43.43,0,0,0,.43-.43A.44.44,0,0,0,47,5.48H43.11a.44.44,0,0,0-.44.44A.44.44,0,0,0,43.11,6.35Z"
                                        />
                                        <path
                                            d="M43.11,11.76H47a.43.43,0,0,0,0-.86H43.11a.43.43,0,1,0,0,.86Z"
                                        />
                                        <path
                                            d="M43.11,17.2H47a.43.43,0,0,0,0-.86H43.11a.43.43,0,1,0,0,.86Z"
                                        />
                                        <path
                                            d="M43.11,22.59H47a.43.43,0,1,0,0-.86H43.11a.43.43,0,1,0,0,.86Z"
                                        />
                                        <path
                                            d="M43.11,28H47a.44.44,0,0,0,.43-.44.43.43,0,0,0-.43-.43H43.11a.44.44,0,0,0-.44.43A.44.44,0,0,0,43.11,28Z"
                                        />
                                        <path
                                            d="M43.11,33.42H47a.43.43,0,1,0,0-.86H43.11a.43.43,0,1,0,0,.86Z"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_agrotemaxia }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΚΑΛΛΙΕΡΓΕΙΕΣ'"
                        :class="{
                            active: propertiesFilter == 'ΚΑΛΛΙΕΡΓΕΙΑ',
                            empty: !total_kaliergies,
                        }"
                        @click="
                            propertiesFilter == 'ΚΑΛΛΙΕΡΓΕΙΑ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΚΑΛΛΙΕΡΓΕΙΑ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΚΑΛΛΙΕΡΓΕΙΑ"
                                viewBox="0 0 56.642 50.9"
                                width="56.642"
                                height="50.9"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M21.2,768.814h-.013a.5.5,0,0,0-.013,1c.239.006,24.015.791,41.146,17.782a.5.5,0,1,0,.7-.711C45.607,769.608,21.445,768.82,21.2,768.814Z"
                                    fill="#212125"
                                    data-name="Path 6288"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M20.989,774.153a.511.511,0,0,0-.547.449.5.5,0,0,0,.449.547c.185.017,18.568,1.924,29.788,12.523a.494.494,0,0,0,.343.137.5.5,0,0,0,.344-.863C39.9,776.114,21.176,774.171,20.989,774.153Z"
                                    fill="#212125"
                                    data-name="Path 6289"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M20.8,779.5a.5.5,0,0,0-.224.975c.131.03,13.164,3.072,18.48,7.294a.5.5,0,1,0,.621-.783C34.185,782.623,21.345,779.626,20.8,779.5Z"
                                    fill="#212125"
                                    data-name="Path 6290"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M76.818,773.875a.5.5,0,0,0-.6-.375,91.589,91.589,0,0,0-12.053,3.8q-2.718-1.9-5.436-3.47a66.4,66.4,0,0,1,17.4-4.682.5.5,0,1,0-.1-1,67.512,67.512,0,0,0-18.388,5.063c-2.1-1.173-4.171-2.214-6.211-3.134a69.055,69.055,0,0,1,24.41-6.268.5.5,0,0,0-.013-1h-.013a70.23,70.23,0,0,0-25.588,6.731c-2.2-.949-4.346-1.761-6.414-2.456a75.875,75.875,0,0,1,31.742-8.111,1,1,0,1,0,.043-2c-.662-.017-16.58-.242-34.494,9.253a72.144,72.144,0,0,0-19.685-3.253A1,1,0,0,0,20.442,764a1.031,1.031,0,0,0,1.022.979c.284,0,29.234-.362,52.155,22.9a1,1,0,0,0,1.424-1.4,77.327,77.327,0,0,0-9.911-8.48,91.712,91.712,0,0,1,11.311-3.515A.5.5,0,0,0,76.818,773.875Z"
                                    fill="#212125"
                                    data-name="Path 6291"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="m46.486 747.88a4.913 4.913 0 1 0-4.914 4.913 4.919 4.919 0 0 0 4.914-4.913zm-4.914 3.913a3.913 3.913 0 1 1 3.914-3.913 3.918 3.918 0 0 1-3.914 3.913z"
                                    fill="#212125"
                                    data-name="Path 6292"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M48.651,747.778a.5.5,0,0,0,.5.5h2.427a.5.5,0,1,0,0-1H49.151A.5.5,0,0,0,48.651,747.778Z"
                                    fill="#212125"
                                    data-name="Path 6293"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M31.567,748.278h2.427a.5.5,0,0,0,0-1H31.567a.5.5,0,0,0,0,1Z"
                                    fill="#212125"
                                    data-name="Path 6294"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M41.573,740.7a.5.5,0,0,0,.5-.5v-2.427a.5.5,0,0,0-1,0V740.2A.5.5,0,0,0,41.573,740.7Z"
                                    fill="#212125"
                                    data-name="Path 6295"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M41.072,755.356v2.427a.5.5,0,0,0,1,0v-2.427a.5.5,0,0,0-1,0Z"
                                    fill="#212125"
                                    data-name="Path 6296"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M48.136,744.488a.5.5,0,0,0,.25-.068l2.1-1.213a.5.5,0,1,0-.5-.865l-2.1,1.213a.5.5,0,0,0,.25.933Z"
                                    fill="#212125"
                                    data-name="Path 6297"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M34.76,751.134l-2.1,1.214a.5.5,0,1,0,.5.865L35.26,752a.5.5,0,0,0-.5-.865Z"
                                    fill="#212125"
                                    data-name="Path 6298"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M37.35,741.464a.5.5,0,0,0,.866-.5L37,738.863a.5.5,0,0,0-.866.5Z"
                                    fill="#212125"
                                    data-name="Path 6299"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M46.142,756.693a.5.5,0,0,0,.866-.5l-1.213-2.1a.5.5,0,0,0-.866.5Z"
                                    fill="#212125"
                                    data-name="Path 6300"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M45.112,741.647a.494.494,0,0,0,.25.067.5.5,0,0,0,.433-.25l1.213-2.1a.5.5,0,0,0-.866-.5l-1.213,2.1A.5.5,0,0,0,45.112,741.647Z"
                                    fill="#212125"
                                    data-name="Path 6301"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M36.32,756.875a.5.5,0,0,0,.683-.182l1.213-2.1a.5.5,0,0,0-.866-.5l-1.213,2.1A.5.5,0,0,0,36.32,756.875Z"
                                    fill="#212125"
                                    data-name="Path 6302"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M32.658,743.207l2.1,1.213a.5.5,0,0,0,.5-.865l-2.1-1.213a.5.5,0,1,0-.5.865Z"
                                    fill="#212125"
                                    data-name="Path 6303"
                                />
                                <path
                                    transform="translate(-20.189 -737.27)"
                                    d="M47.886,752l2.1,1.214a.5.5,0,1,0,.5-.865l-2.1-1.214a.5.5,0,1,0-.5.865Z"
                                    fill="#212125"
                                    data-name="Path 6304"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_kaliergies }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ'"
                        :class="{
                            active: propertiesFilter == 'ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ',
                            empty: !total_dendrokaliergies,
                        }"
                        @click="
                            propertiesFilter == 'ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="57.9"
                                height="31.68"
                                viewBox="0 0 57.9 31.68"
                            >
                                <g id="Layer_2" data-name="Layer 2">
                                    <g id="FILL">
                                        <path
                                            class="cls-1"
                                            d="M56.9,29.68H49.55V20.79a8.5,8.5,0,1,0-2-16.88,9,9,0,0,0-1.62.36A8.47,8.47,0,0,0,38.55,0,8.55,8.55,0,0,0,31.2,4.27a8.48,8.48,0,0,0-5.27,0A8.46,8.46,0,0,0,18.58,0a8.57,8.57,0,0,0-7.36,4.28,8.5,8.5,0,1,0-3.69,16.5v8.89H1a1,1,0,0,0,0,2H56.9a1,1,0,0,0,0-2ZM29.54,20.79A8.5,8.5,0,0,0,36,16.59a8.37,8.37,0,0,0,5.28,0,8.53,8.53,0,0,0,6.36,4.2v8.89h-18Zm26.51-8.44a7.51,7.51,0,0,1-6.51,7.43V14a1,1,0,0,0-2,0v5.76a7.5,7.5,0,1,1,8.51-7.43ZM38.54,1A7.46,7.46,0,0,1,45,4.65a8.49,8.49,0,0,0-4.24,11,7.53,7.53,0,0,1-4.36,0,8.49,8.49,0,0,0-4.24-11A7.44,7.44,0,0,1,38.54,1ZM36.05,12.35a7.51,7.51,0,0,1-6.5,7.43V14a1,1,0,0,0-2,0v5.76a7.5,7.5,0,1,1,8.5-7.43ZM18.57,1A7.47,7.47,0,0,1,25,4.63a8.5,8.5,0,0,0-4.26,11.06,7.53,7.53,0,0,1-4.36,0,8.49,8.49,0,0,0-4.21-11A7.45,7.45,0,0,1,18.57,1ZM1,12.35a7.51,7.51,0,1,1,8.5,7.43V14a1,1,0,0,0-2,0v5.76A7.51,7.51,0,0,1,1,12.35Zm8.5,8.44A8.51,8.51,0,0,0,16,16.58a8.37,8.37,0,0,0,5.28,0,8.52,8.52,0,0,0,6.36,4.19v8.89h-18Z"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_dendrokaliergies }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΔΑΣΙΚΗ ΕΚΤΑΣΗ'"
                        :class="{
                            active: propertiesFilter == 'ΔΑΣΙΚΗ ΕΚΤΑΣΗ',
                            empty: !total_dasiki_ektasi,
                        }"
                        @click="
                            propertiesFilter == 'ΔΑΣΙΚΗ ΕΚΤΑΣΗ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΔΑΣΙΚΗ ΕΚΤΑΣΗ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id=""
                                xmlns="http://www.w3.org/2000/svg"
                                width="60"
                                height="60"
                                viewBox="0 0 60 60"
                            >
                                <path
                                    d="M13.32,30.93a.5.5,0,0,0-.71,0l-2,2v1.42l2.68-2.68A.5.5,0,0,0,13.32,30.93Z"
                                />
                                <path
                                    class="cls-1"
                                    d="M6.95,30.93a.5.5,0,0,0,0,.71l2.68,2.68V32.91l-2-2A.5.5,0,0,0,6.95,30.93Z"
                                />
                                <path
                                    class="cls-1"
                                    d="M33.2,24.17a.5.5,0,0,0-.71,0l-2,2v1.42l2.68-2.68A.5.5,0,0,0,33.2,24.17Z"
                                />
                                <path
                                    class="cls-1"
                                    d="M54.31,31.29a5.86,5.86,0,0,0,2.43-11.12,5.22,5.22,0,0,0,1-3.11,5,5,0,0,0-4.13-5,4.36,4.36,0,0,0,.43-1.87,4.21,4.21,0,1,0-8.42,0,4.35,4.35,0,0,0,.43,1.86,5,5,0,0,0-4.13,5,5.16,5.16,0,0,0,1,3.1,5.8,5.8,0,0,0-3.26,5.28,5.66,5.66,0,0,0,.68,2.8,5.76,5.76,0,0,0,5,3,5.66,5.66,0,0,0,2.82-.77h0a5.34,5.34,0,0,0,1-.75l.13-.14v6.53a78.11,78.11,0,0,0-8.92,3.27c-2.55,1.14-5.09,2.41-7.54,3.64l-2.39,1.19V36.41l.13.14h0a5.34,5.34,0,0,0,1,.75h0a5.62,5.62,0,0,0,2.81.77,5.86,5.86,0,0,0,2.43-11.12,5.22,5.22,0,0,0,1-3.11,5,5,0,0,0-4.13-5A4.36,4.36,0,0,0,34.22,17a4.21,4.21,0,1,0-8.42,0,4.34,4.34,0,0,0,.43,1.86,5,5,0,0,0-4.13,5,5.16,5.16,0,0,0,1,3.1,5.8,5.8,0,0,0-3.26,5.28,5.66,5.66,0,0,0,.68,2.8,5.76,5.76,0,0,0,5,3,5.66,5.66,0,0,0,2.82-.77h0a5.33,5.33,0,0,0,1-.75h0l.13-.14v8.35a73.35,73.35,0,0,1-12.67,5.09c-1.26.35-3.7.78-6.2,1.18V43.17l.13.14h0a5.32,5.32,0,0,0,1,.75h0a5.62,5.62,0,0,0,2.81.77A5.86,5.86,0,0,0,17,33.7a5.22,5.22,0,0,0,1-3.11,5,5,0,0,0-4.13-5,4.36,4.36,0,0,0,.43-1.87,4.26,4.26,0,0,0-4.2-4.31,4.27,4.27,0,0,0-4.21,4.32,4.34,4.34,0,0,0,.43,1.86,5,5,0,0,0-4.13,5,5.16,5.16,0,0,0,1,3.1A5.8,5.8,0,0,0,0,39a5.66,5.66,0,0,0,.68,2.8,5.76,5.76,0,0,0,5,3,5.66,5.66,0,0,0,2.82-.77h0a5.35,5.35,0,0,0,1-.75h0l.13-.14v8c-3.5.54-6.82,1-6.88,1a1,1,0,0,0,.13,1.93H3c.45-.06,11-1.47,14.34-2.39,5.8-1.59,11.2-4.3,16.42-6.92,2.43-1.22,5-2.48,7.46-3.6a109,109,0,0,1,15.22-5.07l.76-.21a1,1,0,0,0-.52-1.86l-.76.21c-1.84.51-3.7,1-5.56,1.59V29.64l.13.14h0a5.34,5.34,0,0,0,1,.75h0A5.62,5.62,0,0,0,54.31,31.29ZM9.63,41.49h0Zm.5-11.84a.5.5,0,0,0-.5.5v2.76h0v7.37h0L6.52,37.17a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l3.78,3.77h0a4.51,4.51,0,0,1-.87,1l-.08.07h0a4.65,4.65,0,0,1-3,1.08A4.76,4.76,0,0,1,1,39a4.82,4.82,0,0,1,3.26-4.62A.5.5,0,0,0,4.59,34a.51.51,0,0,0-.13-.47,4.15,4.15,0,0,1-1.23-2.94,4,4,0,0,1,4-4.08.51.51,0,0,0,.45-.28.49.49,0,0,0,0-.52,3.41,3.41,0,0,1-.66-2,3.26,3.26,0,0,1,3.21-3.31,3.26,3.26,0,0,1,3.2,3.3,3.38,3.38,0,0,1-.66,2,.5.5,0,0,0,.43.8A4,4,0,0,1,17,30.58a4.15,4.15,0,0,1-1.23,3,.51.51,0,0,0-.14.47.5.5,0,0,0,.33.36A4.82,4.82,0,0,1,19.26,39a4.76,4.76,0,0,1-4.69,4.84,4.65,4.65,0,0,1-3-1.09q.1.09,0,0l-.07-.06h0a4.49,4.49,0,0,1-.87-1l0,0,0,0,3.77-3.77a.5.5,0,0,0,0-.71.49.49,0,0,0-.71,0l-3.11,3.11h0V32.91h0V30.15A.5.5,0,0,0,10.13,29.65ZM30,22.89a.5.5,0,0,0-.5.5v2.76h0l-2-2a.5.5,0,0,0-.71.71l2.68,2.68v5.95L26.4,30.41a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l3.78,3.77h0a4.5,4.5,0,0,1-.87,1l-.08.07h0a4.64,4.64,0,0,1-3,1.08,4.76,4.76,0,0,1-4.68-4.83,4.82,4.82,0,0,1,3.26-4.62.5.5,0,0,0,.33-.36.51.51,0,0,0-.13-.47,4.14,4.14,0,0,1-1.23-2.94,4,4,0,0,1,4-4.08.51.51,0,0,0,.45-.28.49.49,0,0,0,0-.52,3.41,3.41,0,0,1-.66-2,3.2,3.2,0,1,1,6.41,0,3.37,3.37,0,0,1-.66,2,.5.5,0,0,0,.43.8,4,4,0,0,1,3.94,4.06,4.15,4.15,0,0,1-1.23,3,.51.51,0,0,0-.14.47.5.5,0,0,0,.33.36,4.82,4.82,0,0,1,3.26,4.61,4.76,4.76,0,0,1-4.69,4.84,4.64,4.64,0,0,1-3-1.09c.06.06.06.06,0,0l-.07-.06h0a4.49,4.49,0,0,1-.87-1l0,0h0l0,0,3.77-3.77a.5.5,0,0,0,0-.71.49.49,0,0,0-.71,0l-3.11,3.11h0V26.15h0V23.39A.5.5,0,0,0,30,22.89ZM49.36,28h0Zm2,1.24-.07-.06h0a4.48,4.48,0,0,1-.87-1l0,0h0l0,0,3.77-3.77a.5.5,0,0,0,0-.71.49.49,0,0,0-.71,0l-3.11,3.11V20.8l2.68-2.68a.5.5,0,0,0-.71-.71l-2,2V16.62a.5.5,0,1,0-1,0v2.76h0v7.37h0l-3.11-3.11a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l3.78,3.77h0a4.5,4.5,0,0,1-.87,1l-.08.07h0a4.64,4.64,0,0,1-3,1.08,4.76,4.76,0,0,1-4.68-4.83A4.82,4.82,0,0,1,44,20.84a.5.5,0,0,0,.33-.36.51.51,0,0,0-.13-.47A4.15,4.15,0,0,1,43,17.06a4,4,0,0,1,4-4.08.51.51,0,0,0,.45-.28.49.49,0,0,0,0-.52,3.41,3.41,0,0,1-.66-2,3.2,3.2,0,1,1,6.41,0,3.37,3.37,0,0,1-.66,2,.5.5,0,0,0,.43.8,4,4,0,0,1,3.94,4.06,4.15,4.15,0,0,1-1.23,3,.52.52,0,0,0-.14.47.5.5,0,0,0,.33.36A4.82,4.82,0,0,1,59,25.45a4.76,4.76,0,0,1-4.69,4.84,4.64,4.64,0,0,1-3-1.09C51.42,29.26,51.42,29.26,51.35,29.2Z"
                                />
                                <path
                                    class="cls-1"
                                    d="M46.68,17.4a.5.5,0,0,0,0,.71l2.68,2.68V19.38l-2-2A.5.5,0,0,0,46.68,17.4Z"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_dasiki_ektasi }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΒΟΣΚΟΤΟΠΟΙ'"
                        :class="{
                            active: propertiesFilter == 'ΒΟΣΚΟΤΟΠΟΣ',
                            empty: !total_voskotopoi,
                        }"
                        @click="
                            propertiesFilter == 'ΒΟΣΚΟΤΟΠΟΣ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΒΟΣΚΟΤΟΠΟΣ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΒΟΣΚΟΤΟΠΟΣ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="57.295"
                                height="40.652"
                                viewBox="0 0 57.295 40.652"
                            >
                                <g
                                    id="Group_3444"
                                    data-name="Group 3444"
                                    transform="translate(-27.354 -536.677)"
                                >
                                    <path
                                        id="Path_6274"
                                        data-name="Path 6274"
                                        d="M46.184,548.586a.519.519,0,0,0-.73,0L43.41,550.63V552.1l2.774-2.774A.518.518,0,0,0,46.184,548.586Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6275"
                                        data-name="Path 6275"
                                        d="M39.6,548.586a.517.517,0,0,0,0,.737L42.37,552.1V550.63l-2.043-2.044A.52.52,0,0,0,39.6,548.586Z"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6276"
                                        data-name="Path 6276"
                                        d="M84.576,574.784a1,1,0,0,0-1.3-.556c-7.982,3.2-22.274-1.619-22.4-1.662-.824-.3-1.628-.583-2.422-.855a33.738,33.738,0,0,0,7.621-4.436c4.536-3.21,9.225-6.529,18.069-6.529a.5.5,0,0,0,0-1c-9.162,0-13.984,3.413-18.646,6.714-2.718,1.923-5.306,3.74-8.614,4.725a95.508,95.508,0,0,0-13.478-3.4v-6.544c.046.046.084.1.131.143h0a5.5,5.5,0,0,0,1.039.77h0a5.808,5.808,0,0,0,2.9.793,6.061,6.061,0,0,0,2.512-11.492,5.393,5.393,0,0,0,1.079-3.22,5.19,5.19,0,0,0-4.271-5.166,4.5,4.5,0,0,0,.441-1.93,4.352,4.352,0,1,0-8.7.012,4.487,4.487,0,0,0,.441,1.918,5.193,5.193,0,0,0-4.271,5.178,5.332,5.332,0,0,0,1.079,3.208,6,6,0,0,0-3.374,5.458,5.845,5.845,0,0,0,.708,2.894,5.954,5.954,0,0,0,5.167,3.14,5.851,5.851,0,0,0,2.911-.793h0a5.454,5.454,0,0,0,1.039-.77h0c.048-.044.085-.1.131-.143v6.372c-9.068-1.429-13.915-.493-14.219-.43a1,1,0,0,0,.4,1.959c.11-.019,11.276-2.144,31.659,5.314a57.33,57.33,0,0,0,16.19,2.877,20.714,20.714,0,0,0,7.619-1.245A1,1,0,0,0,84.576,574.784ZM43.455,559.667m0,0-.565-12.4a.522.522,0,0,0-.52.519v10.465h0l-3.214-3.214a.516.516,0,0,0-.736,0,.526.526,0,0,0,0,.736l3.9,3.9h0a4.675,4.675,0,0,1-.9,1.051h0c-.029.022-.052.045-.081.068h0a4.8,4.8,0,0,1-3.059,1.119,4.919,4.919,0,0,1-4.836-4.989,4.985,4.985,0,0,1,3.369-4.773.514.514,0,0,0,.336-.377.528.528,0,0,0-.137-.485,4.286,4.286,0,0,1-1.273-3.043,4.147,4.147,0,0,1,4.088-4.213.528.528,0,0,0,.462-.291.505.505,0,0,0-.04-.537,3.521,3.521,0,0,1-.679-2.061,3.313,3.313,0,1,1,6.622-.006,3.49,3.49,0,0,1-.685,2.067.52.52,0,0,0,.445.828,4.148,4.148,0,0,1,4.071,4.2,4.292,4.292,0,0,1-1.273,3.054.532.532,0,0,0-.143.485.523.523,0,0,0,.337.377,4.979,4.979,0,0,1,3.374,4.761,4.924,4.924,0,0,1-4.847,5,4.8,4.8,0,0,1-3.054-1.125h0a.838.838,0,0,1-.074-.062h0a4.633,4.633,0,0,1-.9-1.051l3.9-3.9a.519.519,0,0,0,0-.736.51.51,0,0,0-.731,0l-3.214,3.214h0V547.781A.522.522,0,0,0,42.89,547.262Z"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_voskotopoi }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΠΙΣΙΝΕΣ'"
                        :class="{
                            active: propertiesFilter == 'ΠΙΣΙΝΑ',
                            empty: !total_pisina,
                        }"
                        @click="
                            propertiesFilter == 'ΠΙΣΙΝΑ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΠΙΣΙΝΑ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΠΙΣΙΝΑ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="46"
                                height="43.721"
                                viewBox="0 0 46 43.721"
                            >
                                <g
                                    id="Group_3681"
                                    data-name="Group 3681"
                                    transform="translate(-1161 -2814)"
                                >
                                    <path
                                        id="Path_6348"
                                        data-name="Path 6348"
                                        d="M157.3,1062.414a4.487,4.487,0,0,0-3.468-1.764.764.764,0,1,0,0,1.528,3.017,3.017,0,0,1,2.363,1.291,4.291,4.291,0,0,0,6.937,0,2.81,2.81,0,0,1,4.728,0,4.294,4.294,0,0,0,6.94,0,2.812,2.812,0,0,1,4.73,0,4.3,4.3,0,0,0,6.943,0,3.02,3.02,0,0,1,2.365-1.291.764.764,0,1,0,0-1.528,4.5,4.5,0,0,0-3.471,1.764,2.812,2.812,0,0,1-4.731,0,4.739,4.739,0,0,0-2.835-1.72V1046.3a2.313,2.313,0,0,1,3.914-1.67.764.764,0,0,0,1.057-1.1,3.84,3.84,0,0,0-6.5,2.773v5.224h-10.1V1046.3a2.313,2.313,0,0,1,3.914-1.67.763.763,0,1,0,1.056-1.1,3.84,3.84,0,0,0-6.5,2.773v14.442a4.893,4.893,0,0,0-2.615,1.672,2.808,2.808,0,0,1-4.727,0Zm8.869-10.126h10.1v3.875h-10.1Zm0,4.639h10.1v3.823a4.926,4.926,0,0,0-2.578,1.664,2.809,2.809,0,0,1-4.728,0,4.763,4.763,0,0,0-2.8-1.712Z"
                                        transform="translate(1012.666 1771.541)"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6349"
                                        data-name="Path 6349"
                                        d="M188.837,1076.794a4.494,4.494,0,0,0-3.471,1.765,2.813,2.813,0,0,1-4.731,0,4.3,4.3,0,0,0-6.941,0,2.81,2.81,0,0,1-4.728,0,4.294,4.294,0,0,0-6.94,0,2.809,2.809,0,0,1-4.727,0,4.485,4.485,0,0,0-3.468-1.765.764.764,0,1,0,0,1.528,3.017,3.017,0,0,1,2.363,1.291,4.291,4.291,0,0,0,6.937,0,2.81,2.81,0,0,1,4.728,0,4.294,4.294,0,0,0,6.94,0,2.812,2.812,0,0,1,4.73,0,4.3,4.3,0,0,0,6.943,0,3.02,3.02,0,0,1,2.365-1.291.764.764,0,1,0,0-1.528Z"
                                        transform="translate(1012.666 1763.436)"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6350"
                                        data-name="Path 6350"
                                        d="M188.837,1087.317a4.5,4.5,0,0,0-3.471,1.765,2.813,2.813,0,0,1-4.731,0,4.3,4.3,0,0,0-6.941,0,2.81,2.81,0,0,1-4.728,0,4.294,4.294,0,0,0-6.94,0,2.808,2.808,0,0,1-4.727,0,4.487,4.487,0,0,0-3.468-1.765.764.764,0,0,0,0,1.528,3.018,3.018,0,0,1,2.363,1.292,4.292,4.292,0,0,0,6.937,0,2.809,2.809,0,0,1,4.728,0,4.295,4.295,0,0,0,6.94,0,2.811,2.811,0,0,1,4.73,0,4.3,4.3,0,0,0,6.943,0,3.021,3.021,0,0,1,2.365-1.292.764.764,0,0,0,0-1.528Z"
                                        transform="translate(1012.666 1760.952)"
                                        fill="#212125"
                                    />
                                    <path
                                        id="Path_6351"
                                        data-name="Path 6351"
                                        d="M192.108,1059.9h-11.64a.764.764,0,1,0,0,1.528h10.876v27.344H148.4v-27.344h10.71a.764.764,0,1,0,0-1.528H147.636a.763.763,0,0,0-.764.764v28.872a.763.763,0,0,0,.764.764h44.472a.764.764,0,0,0,.764-.764v-28.872A.764.764,0,0,0,192.108,1059.9Z"
                                        transform="translate(1014.128 1767.425)"
                                        fill="#212125"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_pisina }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΠΑΡΚΙΝΓΚ'"
                        :class="{
                            active: propertiesFilter == 'ΠΑΡΚΙΝΓΚ',
                            empty: !total_parking,
                        }"
                        @click="
                            propertiesFilter == 'ΠΑΡΚΙΝΓΚ'
                                ? (propertiesFilter = null)
                                : (propertiesFilter = 'ΠΑΡΚΙΝΓΚ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                enable-background="new 0 0 60 60"
                                version="1.1"
                                viewBox="0 0 60 60"
                                width="60"
                                height="60"
                                xml:space="preserve"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="m58.3 23.9-5.1-2.2-22.6-9.6c-0.2-0.1-0.5-0.1-0.8 0l-22.7 9.2-5.4 2.2c-0.5 0.2-0.8 0.8-0.5 1.3 0.2 0.5 0.8 0.8 1.3 0.5l4-1.6v23.3c0 0.6 0.4 1 1 1h45.3c0.6 0 1-0.4 1-1v-22.9l3.8 1.6c0.1 0.1 0.3 0.1 0.4 0.1 0.4 0 0.8-0.2 0.9-0.6 0.1-0.5-0.1-1.1-0.6-1.3zm-6.5 22.1h-43.3v-23.1l21.6-8.8 21.6 9.2v22.7z"
                                />
                                <path
                                    d="m21.4 20.7-3.6 8.9-0.3 0.8h-0.9c-0.6 0-1 0.4-1 1v8.1c0 0.6 0.4 1 1 1h0.9c-0.1 0.2-0.1 0.4-0.1 0.7v1c0 0.9 0.7 1.7 1.7 1.7h0.2c0.9 0 1.7-0.7 1.7-1.7v-1c0-0.2-0.1-0.5-0.1-0.7h18.9c-0.1 0.2-0.1 0.4-0.1 0.7v1c0 0.9 0.7 1.7 1.7 1.7h0.2c0.9 0 1.7-0.7 1.7-1.7v-1c0-0.2-0.1-0.5-0.1-0.7h0.7c0.6 0 1-0.4 1-1v-8.1c0-0.6-0.4-1-1-1h-0.9l-0.2-0.6-3.7-9.1c-0.2-0.4-0.5-0.6-0.9-0.6h-15.9c-0.4 0-0.8 0.2-0.9 0.6zm-1.6 21.4c0 0.4-0.3 0.7-0.7 0.7h-0.2c-0.4 0-0.7-0.3-0.7-0.7v-1c0-0.4 0.3-0.7 0.7-0.7h0.2c0.4 0 0.7 0.3 0.7 0.7v1zm22.1 0c0 0.4-0.3 0.7-0.7 0.7h-0.2c-0.4 0-0.7-0.3-0.7-0.7v-1c0-0.4 0.3-0.7 0.7-0.7h0.2c0.4 0 0.7 0.3 0.7 0.7v1zm1.6-2.6h-27v-8.1h26.9v8.1zm-2-9.1h-23l3.8-9.3h15.4l3.8 9.3z"
                                />
                                <path
                                    d="m21.3 37.6c1.2 0 2.1-1 2.1-2.2s-1-2.1-2.1-2.1c-1.2 0-2.2 1-2.2 2.1s1 2.2 2.2 2.2zm0-3.3c0.6 0 1.1 0.5 1.1 1.1s-0.5 1.2-1.1 1.2-1.2-0.5-1.2-1.2c0-0.6 0.5-1.1 1.2-1.1z"
                                />
                                <path
                                    d="m39 37.6c1.2 0 2.1-1 2.1-2.2s-1-2.1-2.1-2.1c-1.2 0-2.2 1-2.2 2.1s1 2.2 2.2 2.2zm0-3.3c0.6 0 1.1 0.5 1.1 1.1s-0.5 1.2-1.1 1.2-1.2-0.5-1.2-1.2c0.1-0.6 0.6-1.1 1.2-1.1z"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_parking }}
                        </div>
                    </div>
                </div>

                <table v-if="properties.length">
                    <tr>
                        <th>Είδος ακινήτου</th>
                        <th>Έκταση κτίσματος σε τ.μ.</th>
                        <th>Έτος κτήσης</th>
                        <th>Έκταση εδάφους σε τ.μ.</th>
                        <th>∆ήμος</th>
                        <th>Εμπράγματο δικαίωμα</th>
                        <th>Ποσοστό</th>
                        <th>Τρόπος κτήσης</th>
                    </tr>
                    <tr
                        v-for="property in properties"
                        v-bind:key="'property_item' + property.id"
                    >
                        <td>{{ property.type | propertiesValue }}</td>
                        <td v-if="!parseFloat(property.size)"></td>
                        <td v-else>{{ property.size | seprator }}</td>
                        <td>{{ property.date | formatYear }}</td>
                        <td v-if="!parseFloat(property.landsize)"></td>
                        <td v-else>{{ property.landsize | seprator }}</td>
                        <td>{{ property.country }}</td>
                        <td>{{ property.rights }}</td>
                        <td>{{ property.percent | seprator }}%</td>
                        <td>{{ property.howgetit }}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="card vehicles" id="vehicles">
            <h3 class="card__title">ΟΧΗΜΑΤΑ</h3>
            <div class="card__table">
                <div class="card__table__head">
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΜΟΤΟΣΥΚΛΕΤΕΣ'"
                        :class="{
                            active: mobilesFilter == 'ΜΟΤΟΣΥΚΛΕΤΑ',
                            empty: !total_mobile_motorcycles,
                        }"
                        @click="
                            mobilesFilter == 'ΜΟΤΟΣΥΚΛΕΤΑ'
                                ? (mobilesFilter = null)
                                : (mobilesFilter = 'ΜΟΤΟΣΥΚΛΕΤΑ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΜΟΤΟΣΥΚΛΕΤΑ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="55.452"
                                height="33.54"
                                viewBox="0 0 55.452 33.54"
                            >
                                <g
                                    id="Group_3445"
                                    data-name="Group 3445"
                                    transform="translate(-1076.752 -341.194)"
                                >
                                    <path
                                        id="Path_6279"
                                        data-name="Path 6279"
                                        d="M1125.394,356.272l2.52.1a.952.952,0,0,0,.759-.3.993.993,0,0,0,.279-.768c-.371-5.094-2-8.914-4.852-11.353a11.621,11.621,0,0,0-7.886-2.743,1,1,0,0,0-.735,1.576,10.347,10.347,0,0,1,1.892,4.5,10.274,10.274,0,0,0-6.109-2.2c-7.209-.485-8.155,2.966-8.27,3.583-.416,1.846-2.541,1.853-5.726,1.656-.492-.03-.976-.06-1.439-.075-1.794-.061-2-.583-2.511-1.846a11.78,11.78,0,0,0-.667-1.45c-1.3-2.311-3.38-2.379-6.526-2.482l-.52-.017c-4.166-.167-4.612,2.382-4.629,2.489a1,1,0,0,0,.423.984c.662.452,1.29.894,1.9,1.33a19.7,19.7,0,0,0-6.386,7.119,1.159,1.159,0,0,0,.261,1.483.987.987,0,0,0,.628.23,1.02,1.02,0,0,0,.679-.271c3.628-3.233,7.292-4.5,10.905-3.807a47.622,47.622,0,0,1,3.975,3.844l-1.091.907a8.08,8.08,0,0,0-4.43-1.428,8.571,8.571,0,1,0-.6,17.131c.1,0,.2.006.3.006a8.524,8.524,0,0,0,8.342-10.464l1.292-.7a6.049,6.049,0,0,1,.683,3.948,1.46,1.46,0,0,0,.158,1.141,1.512,1.512,0,0,0,.947.7,39.208,39.208,0,0,0,8.947,1.226c3.368,0,4.746-.744,4.967-.878a1,1,0,0,0,.48-.854c0-4.322,1.177-7.575,3.5-9.67C1120.322,355.794,1125.285,356.264,1125.394,356.272Zm-47.633.756a.173.173,0,0,1,.019-.151,18.353,18.353,0,0,1,6.4-6.975c1.406,1.027,2.668,2.006,3.805,2.94C1084.585,352.7,1081.107,354.122,1077.761,357.028Zm16.345,9.106a6.615,6.615,0,0,1-6.8,6.339,6.571,6.571,0,0,1,.227-13.139c.077,0,.154,0,.231,0a6.167,6.167,0,0,1,2.886.774l-4.735,3.94a2.314,2.314,0,0,0-.544,3.315,2.281,2.281,0,0,0,1.768,1.132,2.673,2.673,0,0,0,1.348-.438c.641-.382,3.225-1.79,5.55-3.05A6.689,6.689,0,0,1,1094.106,366.134Zm-6.128,1.067c-.923.551-1.246.305-1.807-.437a1.345,1.345,0,0,1,.371-1.931l7.48-6.223a22.268,22.268,0,0,1,2.705,3.811C1094.543,363.6,1088.992,366.6,1087.978,367.2Zm23.389.711c-1.163.35-4.521.944-11.468-.646.434-2.8-.861-9.495-16.539-20.409a3.917,3.917,0,0,1,2.174-.4l.523.018c3.046.1,4.136.2,4.85,1.465a9.987,9.987,0,0,1,.553,1.214c.564,1.4,1.2,2.993,4.3,3.1.445.016.911.044,1.383.073,2.956.183,7,.433,7.819-3.309,0-.024.479-2.319,6.221-1.928.051,0,5.145.113,6.025,3.664a1,1,0,0,0,.923.759.961.961,0,0,0,.991-.668,10.036,10.036,0,0,0-.971-7.513,9.6,9.6,0,0,1,4.673,2.159c2.209,1.907,3.562,4.877,4.027,8.841l-1.31-.053c-.233-.023-5.867-.578-10.01,3.148C1112.891,359.8,1111.492,363.325,1111.367,367.912Z"
                                        fill="#2a2a2a"
                                    />
                                    <path
                                        id="Path_6280"
                                        data-name="Path 6280"
                                        d="M1129.9,360.317a8.571,8.571,0,1,0-6.566,14.412c.1,0,.2.005.305.005a8.571,8.571,0,0,0,6.261-14.417Zm-1.786,10.652a6.667,6.667,0,0,1-4.71,1.762,6.571,6.571,0,0,1,.222-13.139c.078,0,.157,0,.235,0a6.571,6.571,0,0,1,4.253,11.373Z"
                                        fill="#2a2a2a"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_mobile_motorcycles }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΕΠΙΒΑΤΙΚA'"
                        :class="{ active: mobilesFilter == 'ΕΠΙΒΑΤΙΚΟ' }"
                        @click="
                            mobilesFilter == 'ΕΠΙΒΑΤΙΚΟ'
                                ? (mobilesFilter = null)
                                : (mobilesFilter = 'ΕΠΙΒΑΤΙΚΟ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                id="ΕΠΙΒΑΤΙΚΟ"
                                xmlns="http://www.w3.org/2000/svg"
                                width="71.746"
                                height="30.68"
                                viewBox="0 0 71.746 30.68"
                            >
                                <path
                                    id="Path_6278"
                                    data-name="Path 6278"
                                    d="M1137.878,257.209c-2.228-2.507-5.466-3.2-8.6-3.87a22.368,22.368,0,0,1-5.727-1.76,20.49,20.49,0,0,1-4.217-3.293,22.533,22.533,0,0,0-4.658-3.608c-2.623-1.374-5.579-1.692-8.635-1.919-3.318-.233-6.979-.4-10.885-.493l-.586-.107-.017.1c-4.821-.069-9.484-.078-15.226.126-.443.017-.875.037-1.3.058l-1.065.047.078,2,1.083-.048c.42-.02.846-.04,1.278-.057,2.676-.1,5.111-.142,7.44-.16a32.448,32.448,0,0,0-4.9,5.881.5.5,0,0,0,.358.767c1.479.185,3.026.391,4.629.6,2.053.272,4.2.556,6.415.827a156.589,156.589,0,0,0,18.872,1.333,85.109,85.109,0,0,0,9.946-.558c.153.09.3.192.455.276a23.894,23.894,0,0,0,6.242,1.947c2.946.63,5.729,1.226,7.519,3.239,1.883,2.137,2.119,5.235,2.074,8.554q-1.35.043-2.7.091c-1.216.042-2.432.083-3.613.12h-.089a6.772,6.772,0,0,0,.14-1.364,6.914,6.914,0,1,0-13.734,1.108c-11.783-.259-22.238-.623-31.87-1.108h0a6.911,6.911,0,0,0-13.773-.829c-.69-.048-1.382-.1-2.068-.148A19.49,19.49,0,0,1,1080,247.314l-1.018-1.723A21.506,21.506,0,0,0,1068.837,266a1,1,0,0,0,.912.883c1.035.084,2.082.156,3.128.228a6.866,6.866,0,0,0,6.791,5.726,6.942,6.942,0,0,0,6.611-4.917c9.9.5,20.664.873,32.86,1.136a6.876,6.876,0,0,0,12.157.232h.115c.229,0,.459.008.718.008h.046q1.819-.057,3.648-.121t3.644-.12a1,1,0,0,0,.968-.975C1140.535,264.161,1140.42,260.091,1137.878,257.209Zm-54.65-7.233a31.417,31.417,0,0,1,5.112-5.765c1.99,0,3.922.012,5.866.039q-.6,3.492-1.209,6.995c-2.043-.253-4.032-.514-5.934-.766Q1085.086,250.215,1083.228,249.976Zm10.762,1.391q.621-3.551,1.228-7.1c3.83.093,7.426.256,10.681.484,2.835.211,5.569.5,7.848,1.694a20.776,20.776,0,0,1,4.23,3.306,34.108,34.108,0,0,0,2.89,2.464C1111.49,253.167,1101.714,252.3,1093.99,251.367Zm-9.472,15.318a.317.317,0,0,0-.007.044,4.9,4.9,0,0,1-9.735-.593,1.674,1.674,0,0,0-.014-.2,4.914,4.914,0,1,1,9.828,0A3.844,3.844,0,0,1,1084.518,266.685Zm45.263,1.2,0,.005a4.906,4.906,0,0,1-9.08-.2,4.586,4.586,0,0,1-.333-1.757,4.914,4.914,0,1,1,9.828,0A4.83,4.83,0,0,1,1129.781,267.882Z"
                                    transform="translate(-1068.712 -242.159)"
                                    fill="#2a2a2a"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_mobile_cars }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΦΟΡΤΗΓΑ'"
                        :class="{
                            active: mobilesFilter == 'ΦΟΡΤΗΓΟ',
                            empty: !total_mobile_trucks,
                        }"
                        @click="
                            mobilesFilter == 'ΦΟΡΤΗΓΟ'
                                ? (mobilesFilter = null)
                                : (mobilesFilter = 'ΦΟΡΤΗΓΟ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="54.761"
                                height="37.39"
                                viewBox="0 0 54.761 37.39"
                            >
                                <path
                                    id="Path_6312"
                                    data-name="Path 6312"
                                    d="M1123.472,464.6l-.03-10.359a4.653,4.653,0,0,0-1.065-2.945l-6.334-7.663a4.632,4.632,0,0,0-3.578-1.684h-9.581v-1.333a4.172,4.172,0,0,0-4.167-4.167h-25.84a4.171,4.171,0,0,0-4.166,4.167v24.475a4.17,4.17,0,0,0,4.166,4.166h2.375a5.343,5.343,0,0,0,5.328,4.582,5.4,5.4,0,0,0,5.32-4.469c.007-.035,0-.076.011-.113h22.7a5.395,5.395,0,0,0,10.648.112c.009-.043.005-.091.013-.134a4.645,4.645,0,0,0,4.2-4.635Zm-39.072,4.483-.008.033a3.864,3.864,0,0,1-7.665-.459,1.166,1.166,0,0,0-.012-.157,3.87,3.87,0,0,1,7.739,0A2.951,2.951,0,0,1,1084.4,469.086Zm1.52-1.352a5.4,5.4,0,0,0-10.668,0h-2.375a2.643,2.643,0,0,1-2.64-2.639V440.619a2.644,2.644,0,0,1,2.64-2.64h25.84a2.642,2.642,0,0,1,2.639,2.64v27.114h-15.436Zm31.84,1.354-.006.032a3.865,3.865,0,0,1-7.667-.46,1.27,1.27,0,0,0-.01-.157,3.869,3.869,0,0,1,7.738,0A2.967,2.967,0,0,1,1117.759,469.087Zm3.274-2.27a3.083,3.083,0,0,1-1.76.872,5.4,5.4,0,0,0-10.662.044h-5.728V443.48h9.581a3.11,3.11,0,0,1,2.4,1.13l6.334,7.662a3.128,3.128,0,0,1,.715,1.978l0,1.5H1106.8v.763h15.12l.023,8.091A3.093,3.093,0,0,1,1121.034,466.817Z"
                                    transform="translate(-1068.711 -436.452)"
                                    fill="#2a2a2a"
                                />
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_mobile_trucks }}
                        </div>
                    </div>
                    <div
                        class="card__table__head__item"
                        v-tooltip="'ΣΚΑΦΗ ΑΝΑΨΥΧΗΣ'"
                        :class="{
                            active: mobilesFilter == 'ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ',
                            empty: !total_mobile_boats,
                        }"
                        @click="
                            mobilesFilter == 'ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ'
                                ? (mobilesFilter = null)
                                : (mobilesFilter = 'ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ')
                        "
                    >
                        <div class="card__table__head__item__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="47.89"
                                height="41"
                                viewBox="0 0 47.89 41"
                            >
                                <g
                                    id="Group_3681"
                                    data-name="Group 3681"
                                    transform="translate(-971.33 -531.19)"
                                >
                                    <path
                                        id="Path_6310"
                                        data-name="Path 6310"
                                        d="M986.667,563.493a.552.552,0,0,0,.365-.072,32.6,32.6,0,0,1,15.555-3.67,36.84,36.84,0,0,1,9.806,1.338.612.612,0,0,0,.187.028.693.693,0,0,0,.469-.174.589.589,0,0,0,.218-.656c-.072-.656-2.332-15.45-20.551-28.932a.753.753,0,0,0-1.166.8c.072.218,6.049,18.365-5.539,30.171a.688.688,0,0,0-.073.948A1.632,1.632,0,0,0,986.667,563.493Zm25.085-3.974a38.257,38.257,0,0,0-9.164-1.125c-.936,0-1.839.038-2.715.1-.138-15.094-4.685-22.862-6.154-24.662C1007.693,544.888,1011.05,556.265,1011.751,559.519Zm-18.085-24.572c1.6,2.411,5.41,9.644,5.528,23.6a35.929,35.929,0,0,0-10.222,2.44C996,551.879,994.813,540.444,993.667,534.947Z"
                                        transform="translate(-4.649 0)"
                                        fill="#2a2a2a"
                                    />
                                    <path
                                        id="Path_6311"
                                        data-name="Path 6311"
                                        d="M1018.881,586.631a3.637,3.637,0,0,1-2.719-1.267,4.218,4.218,0,0,0-6.359,0,3.553,3.553,0,0,1-5.44,0l-.168-.153.008,0a9.121,9.121,0,0,0,3.965-5.464l.046-.137a1.076,1.076,0,0,0-1.395-1.35c-10.636,3.865-22.041,2.355-24.219,2.013a1.077,1.077,0,0,0-1.24.959,18.282,18.282,0,0,0,1.074,5.164l.029.092a4.4,4.4,0,0,1-1.709-1.121,4.223,4.223,0,0,0-6.363,0,3.647,3.647,0,0,1-2.723,1.267.339.339,0,1,0,0,.678,4.3,4.3,0,0,0,3.181-1.446,3.561,3.561,0,0,1,5.447,0,4.221,4.221,0,0,0,6.362,0,3.557,3.557,0,0,1,5.443,0,4.221,4.221,0,0,0,6.361,0,3.553,3.553,0,0,1,5.44,0,4.218,4.218,0,0,0,6.359,0,3.554,3.554,0,0,1,5.44,0,4.3,4.3,0,0,0,3.179,1.446.339.339,0,0,0,0-.678ZM998,585.364a3.556,3.556,0,0,1-5.443,0,4.221,4.221,0,0,0-6.361,0,3.811,3.811,0,0,1-2.274,1.24l-.2-.623a21.116,21.116,0,0,1-1.021-4.325c2.815.412,13.69,1.647,24.038-1.935a7.438,7.438,0,0,1-3.214,4.307l-.536.306a3.849,3.849,0,0,0-1.81-.418A4.3,4.3,0,0,0,998,585.364Z"
                                        transform="translate(0 -15.119)"
                                        fill="#2a2a2a"
                                    />
                                </g>
                            </svg>
                        </div>
                        <div class="card__table__head__item__text">
                            {{ total_mobile_boats }}
                        </div>
                    </div>
                </div>

                <table v-if="mobile_properties.length">
                    <tr>
                        <th>Είδος οχήματος</th>
                        <th>Κατάσταση / Mεταβολή</th>
                        <th>Κυβισμός / Μήκος</th>
                        <th>Τρόπος κτήσης</th>
                        <th>Έτος Κτήσης</th>
                        <th>Ιδιοκτησία %</th>
                    </tr>
                    <tr
                        v-for="m_property in mobile_properties"
                        v-bind:key="'m_property_item' + m_property.id"
                    >
                        <td>{{ m_property.type | mobilePropertiesValue }}</td>
                        <td>{{ m_property.state }}</td>
                        <td>{{ m_property.cc | seprator }}</td>
                        <td>{{ m_property.howgetit }}</td>
                        <td>{{ m_property.date | formatYear }}</td>
                        <td>{{ m_property.owner | seprator }}%</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { currencyToEuro } from "../../../js-parser/currencyToEuro";

const euroFormatter = new Intl.NumberFormat("el-GR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0, // allow dropping decimals
    maximumFractionDigits: 2,
});

export default {
    props: ["memberfiscal", "partner", "isHalf", "isEmpty"],
    data() {
        return {
            fiscal: null,
            revenuesFilter: null,
            propertiesFilter: null,
            mobilesFilter: null,
        };
    },
    mounted() {},
    created() {},
    methods: {},
    filters: {
        seprator: function (input) {
            if (input == null) return input;
            const str = String(input).trim();
            const num = Number(str);
            if (isNaN(num)) return input;

            // Determine if there's a non-zero fractional part
            const fractional = str.includes(".") ? str.split(".")[1] : "";
            const hasNonZeroFraction = fractional && !/^0+$/.test(fractional);
            const minDigits = hasNonZeroFraction ? fractional.length : 0;

            const formatter = new Intl.NumberFormat("el-GR", {
                style: "decimal",
                minimumFractionDigits: minDigits,
                maximumFractionDigits: 2,
            });

            return formatter.format(num);
        },
        formatDate: function (date) {
            if (date == null) return "";
            const f_date = new Date(date);
            return moment(f_date).format("DD/MM/YYYY");
        },
        formatYear: function (date) {
            if (date == null) return "";
            const f_date = new Date(date);
            return moment(f_date).format("YYYY");
        },
    },
    watch: {
        $props: {
            handler() {
                this.fiscal = this.memberfiscal;
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        properties: function () {
            if (this.propertiesFilter) {
                return this.fiscal.properties.filter(
                    (m_property) =>
                        this.$options.filters
                            .propertiesValue(m_property.type)
                            .includes(this.propertiesFilter) &&
                        m_property.partner == this.partner
                );
            }
            return this.fiscal.properties.filter(
                (property) => property.partner == this.partner
            );
        },
        revenues: function () {
            if (this.revenuesFilter) {
                return this.fiscal.revenues.filter(
                    (revenue) =>
                        this.$options.filters
                            .revenuesValue(revenue.source)
                            .includes(this.revenuesFilter) &&
                        revenue.partner == this.partner
                );
            }
            return this.fiscal.revenues.filter(
                (revenue) => revenue.partner == this.partner
            );
        },
        stocks: function () {
            return this.fiscal.pmproducts.filter(
                (stock) => stock.partner == this.partner
            );
        },
        deposits: function () {
            return this.fiscal.deposits.filter(
                (deposit) => deposit.partner == this.partner
            );
        },
        loans: function () {
            return this.fiscal.loans.filter(
                (loan) => loan.partner == this.partner
            );
        },
        companies: function () {
            return this.fiscal.companies.filter(
                (company) => company.partner == this.partner
            );
        },
        mobile_properties: function () {
            if (this.mobilesFilter) {
                return this.fiscal.mobile_properties.filter(
                    (m_property) =>
                        this.$options.filters
                            .mobilePropertiesValue(m_property.type)
                            .includes(this.mobilesFilter) &&
                        m_property.partner == this.partner
                );
            }
            return this.fiscal.mobile_properties.filter(
                (m_property) => m_property.partner == this.partner
            );
        },
        total_mobile_motorcycles: function () {
            let motrocycles = this.fiscal.mobile_properties.filter(
                (m_property) =>
                    this.$options.filters.mobilePropertiesValue(
                        m_property.type
                    ) == "ΜΟΤΟΣΥΚΛΕΤΑ" && m_property.partner == this.partner
            );
            return motrocycles.length;
        },
        total_mobile_cars: function () {
            let cars = this.fiscal.mobile_properties.filter(
                (m_property) =>
                    this.$options.filters
                        .mobilePropertiesValue(m_property.type)
                        .includes("ΕΠΙΒΑΤΙΚΟ") &&
                    m_property.partner == this.partner
            );
            return cars.length;
        },
        total_mobile_trucks: function () {
            let trucks = this.fiscal.mobile_properties.filter(
                (m_property) =>
                    this.$options.filters
                        .mobilePropertiesValue(m_property.type)
                        .includes("ΦΟΡΤΗΓΟ") &&
                    m_property.partner == this.partner
            );
            return trucks.length;
        },
        total_mobile_boats: function () {
            let boats = this.fiscal.mobile_properties.filter(
                (m_property) =>
                    this.$options.filters
                        .mobilePropertiesValue(m_property.type)
                        .includes("ΣΚΑΦΟΣ ΑΝΑΨΥΧΗΣ") &&
                    m_property.partner == this.partner
            );
            return boats.length;
        },
        total_agrotemaxia: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΑΓΡΟΤΕΜΑΧΙΟ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_dendrokaliergies: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_dasiki_ektasi: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΔΑΣΙΚΗ ΕΚΤΑΣΗ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_kaliergies: function () {
            // let result = this.fiscal.properties.filter(m_property => (this.$options.filters.propertiesValue(m_property.type).includes('ΚΑΛΛΙΕΡΓΕΙΑ')) && m_property.partner == this.partner);
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters.propertiesValue(m_property.type) ==
                        "ΚΑΛΛΙΕΡΓΕΙΑ" && m_property.partner == this.partner
            );
            return result.length;
        },
        total_voskotopoi: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΒΟΣΚΟΤΟΠΟΣ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_pisina: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΠΙΣΙΝΑ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_diamerismata: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΔΙΑΜΕΡΙΣΜΑ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_oikies: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΟΙΚΙΑ") && m_property.partner == this.partner
            );
            return result.length;
        },
        total_apothikes: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΑΠΟΘΗΚΗ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_parking: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΠΑΡΚΙΝΓΚ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_katastimata: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΚΑΤΑΣΤΗΜΑ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },
        total_oikopeda: function () {
            let result = this.fiscal.properties.filter(
                (m_property) =>
                    this.$options.filters
                        .propertiesValue(m_property.type)
                        .includes("ΟΙΚΟΠΕΔΟ") &&
                    m_property.partner == this.partner
            );
            return result.length;
        },

        total_companies: function () {
            if (!this.companies.length) return 0;
            return parseFloat(
                this.companies
                    .map((o) => o.cost)
                    .reduce((a, c) => {
                        return parseFloat(a) + parseFloat(c);
                    })
            ).toFixed(2);
        },
        total_stocks: function () {
            if (!this.stocks.length) return 0;
            return parseFloat(
                this.stocks.reduce((a, c) => {
                    return (
                        a +
                        currencyToEuro(
                            c.cost,
                            c.currency,
                            this.fiscal.year_of_use
                        )
                    );
                }, 0)
            ).toFixed(2);
        },
        total_loans: function () {
            if (!this.loans.length) return 0;
            return parseFloat(
                this.loans.reduce((a, c) => {
                    return (
                        a +
                        currencyToEuro(
                            c.actual,
                            c.currency,
                            this.fiscal.year_of_use
                        )
                    );
                }, 0)
            ).toFixed(2);
        },
        total_deposits: function () {
            if (!this.deposits.length) return 0;
            return parseFloat(
                this.deposits.reduce((a, c) => {
                    return (
                        a +
                        currencyToEuro(
                            c.cost,
                            c.currency,
                            this.fiscal.year_of_use
                        )
                    );
                }, 0)
            ).toFixed(2);
        },
        total_revenues: function () {
            if (!this.revenues.length) return 0;
            return parseFloat(
                this.revenues.reduce((a, c) => {
                    return (
                        a +
                        currencyToEuro(
                            c.amount,
                            c.currency,
                            this.fiscal.year_of_use
                        )
                    );
                }, 0)
            ).toFixed(2);
        },
        total_revenue_epixirimatiki: function () {
            let result = this.fiscal.revenues.filter(
                (revenue) =>
                    this.$options.filters
                        .propertiesValue(revenue.source)
                        .includes("ΕΠΙΧΕΙΡΗΜΑΤΙΚΗ") &&
                    revenue.partner == this.partner
            );
            if (!result.length) return 0;
            return parseFloat(
                result
                    .map((o) => o.amount)
                    .reduce((a, c) => {
                        return parseFloat(a) + parseFloat(c);
                    })
            ).toFixed(2);
        },
        total_revenue_akinita: function () {
            let result = this.fiscal.revenues.filter(
                (revenue) =>
                    this.$options.filters
                        .propertiesValue(revenue.source)
                        .includes("ΑΚΙΝΗΤΑ") && revenue.partner == this.partner
            );
            if (!result.length) return 0;
            return parseFloat(
                result
                    .map((o) => o.amount)
                    .reduce((a, c) => {
                        return parseFloat(a) + parseFloat(c);
                    })
            ).toFixed(2);
        },
        total_revenue_agrotika: function () {
            let result = this.fiscal.revenues.filter(
                (revenue) =>
                    this.$options.filters
                        .propertiesValue(revenue.source)
                        .includes("ΑΓΡΟΤΙΚΗ") && revenue.partner == this.partner
            );
            if (!result.length) return 0;
            return parseFloat(
                result
                    .map((o) => o.amount)
                    .reduce((a, c) => {
                        return parseFloat(a) + parseFloat(c);
                    })
            ).toFixed(2);
        },
        total_revenue_various: function () {
            let result = this.fiscal.revenues.filter(
                (revenue) =>
                    this.$options.filters
                        .propertiesValue(revenue.source)
                        .includes("ΜΙΣΘΩΤΕΣ ΥΠΗΡΕΣΙΕΣ") &&
                    revenue.partner == this.partner
            );
            if (!result.length) return 0;
            return parseFloat(
                result
                    .map((o) => o.amount)
                    .reduce((a, c) => {
                        return parseFloat(a) + parseFloat(c);
                    })
            ).toFixed(2);
        },
        total_revenue_stocks: function () {
            let result = this.fiscal.revenues.filter(
                (revenue) =>
                    this.$options.filters
                        .propertiesValue(revenue.source)
                        .includes("ΤΟΚΟΙ") && revenue.partner == this.partner
            );
            if (!result.length) return 0;
            return parseFloat(
                result
                    .map((o) => o.amount)
                    .reduce((a, c) => {
                        return parseFloat(a) + parseFloat(c);
                    })
            ).toFixed(2);
        },
        total_revenue_efapax: function () {
            let result = this.fiscal.revenues.filter(
                (revenue) =>
                    this.$options.filters
                        .propertiesValue(revenue.source)
                        .includes("ΕΦΑΠΑΞ") && revenue.partner == this.partner
            );
            if (!result.length) return 0;
            return parseFloat(
                result
                    .map((o) => o.amount)
                    .reduce((a, c) => {
                        return parseFloat(a) + parseFloat(c);
                    })
            ).toFixed(2);
        },
        total_revenue_other: function () {
            let result = this.fiscal.revenues.filter(
                (revenue) =>
                    (revenue.source == "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ" ||
                        revenue.source == "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ") &&
                    revenue.partner == this.partner
            );
            if (!result.length) return 0;
            return parseFloat(
                result
                    .map((o) => o.amount)
                    .reduce((a, c) => {
                        return parseFloat(a) + parseFloat(c);
                    })
            ).toFixed(2);
        },
    },
};
</script>
